{
  "nm": "middle-lottie-animation",
  "ddd": 0,
  "h": 1080,
  "w": 1080,
  "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" },
  "layers": [
    {
      "ty": 4,
      "nm": "Layer 1 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [447.773, 13.388, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [550.587, 825.739, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.97, 0],
                    [0, 0],
                    [0, 0.97],
                    [0, 0],
                    [-0.97, 0],
                    [0, 0],
                    [0, -0.971],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.97, 0],
                    [0, 0],
                    [0, -0.971],
                    [0, 0],
                    [0.97, 0],
                    [0, 0],
                    [0, 0.97]
                  ],
                  "v": [
                    [434.717, 2.088],
                    [-434.716, 2.088],
                    [-436.473, 0.331],
                    [-436.473, -0.331],
                    [-434.716, -2.088],
                    [434.717, -2.088],
                    [436.473, -0.331],
                    [436.473, 0.331]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 4.52, "ix": 5 },
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [447.773, 13.388], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.97, 0],
                    [0, 0],
                    [0, 0.97],
                    [0, 0],
                    [-0.97, 0],
                    [0, 0],
                    [0, -0.971],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.97, 0],
                    [0, 0],
                    [0, -0.971],
                    [0, 0],
                    [0.97, 0],
                    [0, 0],
                    [0, 0.97]
                  ],
                  "v": [
                    [434.717, 2.088],
                    [-434.716, 2.088],
                    [-436.473, 0.331],
                    [-436.473, -0.331],
                    [-434.716, -2.088],
                    [434.717, -2.088],
                    [436.473, -0.331],
                    [436.473, 0.331]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [447.773, 13.388], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Layer 10 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [19.302, 23.844, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 706.031, 0],
              "t": 22,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 736.031, 0],
              "t": 67,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 706.031, 0],
              "t": 97,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 736.031, 0],
              "t": 142,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 706.031, 0],
              "t": 172,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 736.031, 0],
              "t": 217,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [758.08, 706.031, 0],
              "t": 247,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            { "s": [758.08, 736.031, 0], "t": 292 }
          ],
          "ix": 2
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 22 },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 44
            },
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 67 },
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 97 },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 119
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 142
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 172
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 194
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 217
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 247
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 269
            },
            { "s": [0], "t": 292 }
          ],
          "ix": 11
        }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [2.08, 0],
                    [0, 2.08],
                    [0, 0],
                    [-2.08, 0],
                    [0, -2.08],
                    [0, 0]
                  ],
                  "o": [
                    [-2.08, 0],
                    [0, 0],
                    [0, -2.08],
                    [2.08, 0],
                    [0, 0],
                    [0, 2.08]
                  ],
                  "v": [
                    [0, 22.825],
                    [-3.766, 19.059],
                    [-3.766, -19.059],
                    [0, -22.825],
                    [3.766, -19.059],
                    [3.766, 19.059]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [19.295, 23.075], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [-1.471, 1.472],
                    [-1.471, -1.471],
                    [0, 0],
                    [0, 0],
                    [-1.461, -1.48],
                    [1.483, -1.46]
                  ],
                  "o": [
                    [0, 0],
                    [-1.471, -1.471],
                    [1.471, -1.471],
                    [0, 0],
                    [0, 0],
                    [1.485, -1.457],
                    [1.458, 1.485],
                    [0, 0]
                  ],
                  "v": [
                    [-0.154, 12.116],
                    [-17.581, -5.31],
                    [-17.581, -10.636],
                    [-12.255, -10.636],
                    [-0.111, 1.508],
                    [12.266, -10.659],
                    [17.594, -10.614],
                    [17.547, -5.286]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [19.301, 35.321], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 2
    },
    {
      "ty": 4,
      "nm": "Layer 2 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [105.838, 95.55, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [752.125, 728.662, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [4.708, 0],
                    [0, 0],
                    [0, 4.465],
                    [0, 0],
                    [-2.08, 0],
                    [0, -2.081],
                    [0, 0],
                    [-0.312, 0],
                    [0, 0],
                    [0, 0.555],
                    [0, 0],
                    [-2.08, 0],
                    [0, -2.081],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-4.465, 0],
                    [0, 0],
                    [0, -2.081],
                    [2.08, 0],
                    [0, 0],
                    [0, 0.311],
                    [0, 0],
                    [0.555, 0],
                    [0, 0],
                    [0, -2.081],
                    [2.081, 0],
                    [0, 0],
                    [0, 4.708]
                  ],
                  "v": [
                    [27.73, 16.087],
                    [-28.168, 16.087],
                    [-36.267, 7.988],
                    [-36.267, -12.32],
                    [-32.501, -16.087],
                    [-28.736, -12.32],
                    [-28.736, 7.988],
                    [-28.168, 8.554],
                    [27.73, 8.554],
                    [28.734, 7.549],
                    [28.734, -12.32],
                    [32.501, -16.087],
                    [36.267, -12.32],
                    [36.267, 7.549]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [111.788, 126.99], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.833, 0],
                    [0, 0.833],
                    [0, 0],
                    [3.664, 0],
                    [0, 0],
                    [0, 0.833],
                    [-0.833, 0],
                    [0, 0],
                    [0, -5.022],
                    [0, 0]
                  ],
                  "o": [
                    [-0.833, 0],
                    [0, 0],
                    [0, -3.361],
                    [0, 0],
                    [-0.833, 0],
                    [0, -0.832],
                    [0, 0],
                    [5.325, 0],
                    [0, 0],
                    [0, 0.833]
                  ],
                  "v": [
                    [11.372, 15.319],
                    [9.865, 13.813],
                    [9.865, -6.212],
                    [3.221, -12.306],
                    [-11.372, -12.306],
                    [-12.878, -13.814],
                    [-11.372, -15.319],
                    [3.221, -15.319],
                    [12.878, -6.212],
                    [12.878, 13.813]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [188.146, 26.912], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -4.063],
                    [4.062, 0],
                    [0, 4.063],
                    [-4.063, 0]
                  ],
                  "o": [
                    [0, 4.063],
                    [-4.063, 0],
                    [0, -4.063],
                    [4.062, 0]
                  ],
                  "v": [
                    [7.357, 0],
                    [0, 7.356],
                    [-7.357, 0],
                    [0, -7.356]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [187.021, 166.588], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [7.25, -0.015],
                    [0, 0],
                    [-0.016, -7.251],
                    [0, 0],
                    [0, 0],
                    [-0.023, -11.081],
                    [0, 0],
                    [-11.079, 0.024],
                    [0, 0],
                    [0.024, 11.081],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-7.25, 0.015],
                    [0, 0],
                    [0, 0],
                    [-11.079, 0.023],
                    [0, 0],
                    [0.024, 11.081],
                    [0, 0],
                    [11.078, -0.023],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.015, -7.252]
                  ],
                  "v": [
                    [78.931, -83.265],
                    [39.831, -83.183],
                    [26.677, -69.971],
                    [26.716, -51.256],
                    [-72.319, -51.048],
                    [-92.42, -30.859],
                    [-92.223, 63.16],
                    [-72.037, 83.264],
                    [72.319, 82.961],
                    [92.419, 62.772],
                    [92.226, -29.321],
                    [92.222, -31.247],
                    [92.14, -70.108]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8745, 0.4784, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [113.172, 102.531], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [88.224, -93.041],
                    [88.238, -93.041]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [2.36, -2.369],
                    [-0.007, -3.315],
                    [0, 0],
                    [1.248, -0.003],
                    [0, 0],
                    [-0.023, -11.167],
                    [0, 0],
                    [-11.15, 0],
                    [0, 0],
                    [0, 0],
                    [-3.829, 3.846],
                    [0.012, 5.385],
                    [0, 0],
                    [2.369, 2.359],
                    [3.305, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-3.315, 0.008],
                    [-2.358, 2.369],
                    [0, 0],
                    [0.003, 1.248],
                    [0, 0],
                    [-11.167, 0.024],
                    [0, 0],
                    [0.022, 11.153],
                    [0, 0],
                    [0, 0],
                    [5.385, -0.01],
                    [3.83, -3.844],
                    [0, 0],
                    [-0.006, -3.314],
                    [-2.362, -2.352],
                    [0, 0]
                  ],
                  "v": [
                    [88.227, -90.781],
                    [44.529, -90.689],
                    [35.728, -87.006],
                    [32.082, -78.191],
                    [32.125, -57.278],
                    [29.87, -55.014],
                    [-80.814, -54.782],
                    [-101.023, -34.486],
                    [-100.802, 70.57],
                    [-80.549, 90.781],
                    [-80.508, 90.781],
                    [80.828, 90.441],
                    [95.117, 84.459],
                    [101.038, 70.145],
                    [100.727, -78.335],
                    [97.042, -87.133],
                    [88.255, -90.781]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0.028, 13.642],
                    [0, 0],
                    [-13.661, 0.03],
                    [0, 0],
                    [0, 0],
                    [-3.212, 3.223],
                    [-4.523, 0.011],
                    [0, 0],
                    [0, 0],
                    [-3.217, -3.201],
                    [-0.009, -4.523],
                    [0, 0],
                    [4.682, -4.701],
                    [6.593, -0.014],
                    [0, 0]
                  ],
                  "o": [
                    [-13.639, 0],
                    [0, 0],
                    [-0.029, -13.658],
                    [0, 0],
                    [0, 0],
                    [-0.01, -4.521],
                    [3.21, -3.225],
                    [0, 0],
                    [0, 0],
                    [4.51, 0],
                    [3.223, 3.211],
                    [0, 0],
                    [0.014, 6.592],
                    [-4.681, 4.701],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-80.549, 95.3],
                    [-105.323, 70.579],
                    [-105.544, -34.477],
                    [-80.823, -59.301],
                    [27.602, -59.529],
                    [27.563, -78.183],
                    [32.527, -90.193],
                    [44.519, -95.209],
                    [88.219, -95.3],
                    [88.255, -95.3],
                    [100.232, -90.337],
                    [105.246, -78.343],
                    [105.558, 70.136],
                    [98.32, 87.649],
                    [80.837, 94.96],
                    [-80.499, 95.3]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.823, 95.55], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [8.103, -0.017],
                    [0, 0],
                    [-0.017, -8.103],
                    [0, 0],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-8.103, 0.017],
                    [0, 0],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [0.026, 12.381],
                    [0, 0],
                    [12.382, -0.026],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.017, -8.102]
                  ],
                  "v": [
                    [88.216, -93.045],
                    [44.516, -92.952],
                    [29.815, -78.189],
                    [29.859, -57.278],
                    [-80.826, -57.045],
                    [-103.291, -34.485],
                    [-103.07, 70.571],
                    [-80.511, 93.036],
                    [80.826, 92.697],
                    [103.291, 70.137],
                    [103.075, -32.768],
                    [103.071, -34.92],
                    [102.979, -78.343]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.83, 95.554], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [8.28, 0],
                    [0, 0],
                    [0, 0],
                    [2.844, -2.858],
                    [-0.009, -4],
                    [0, 0],
                    [-8.281, 0],
                    [0, 0],
                    [0, 0],
                    [0.018, 8.297],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [-4, 0.009],
                    [-2.846, 2.857],
                    [0, 0],
                    [0.017, 8.286],
                    [0, 0],
                    [0, 0],
                    [8.296, -0.018],
                    [0, 0],
                    [-0.017, -8.284]
                  ],
                  "v": [
                    [86.501, -73.716],
                    [86.469, -73.716],
                    [-86.787, -73.353],
                    [-97.402, -68.909],
                    [-101.801, -58.275],
                    [-101.555, 58.7],
                    [-86.51, 73.716],
                    [-86.478, 73.716],
                    [86.778, 73.351],
                    [101.792, 58.273],
                    [101.546, -58.702]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0.021, 9.946],
                    [0, 0],
                    [-3.413, 3.426],
                    [-4.805, 0.01],
                    [0, 0],
                    [0, 0],
                    [-0.02, -9.945],
                    [0, 0],
                    [9.958, -0.021],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-9.94, 0],
                    [0, 0],
                    [-0.011, -4.805],
                    [3.412, -3.428],
                    [0, 0],
                    [0, 0],
                    [9.94, 0],
                    [0, 0],
                    [0.021, 9.958],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-86.51, 76.729],
                    [-104.569, 58.706],
                    [-104.814, -58.269],
                    [-99.537, -71.035],
                    [-86.793, -76.366],
                    [86.463, -76.729],
                    [86.501, -76.729],
                    [104.559, -58.708],
                    [104.805, 58.267],
                    [86.783, 76.364],
                    [86.781, 74.857],
                    [86.783, 76.364],
                    [-86.472, 76.729]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.851, 105.877], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 8",
          "ix": 8,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [9.104, -0.019],
                    [0, 0],
                    [0.019, 9.104],
                    [0, 0],
                    [-9.104, 0.019],
                    [0, 0],
                    [-0.02, -9.104],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-9.105, 0.019],
                    [0, 0],
                    [-0.019, -9.105],
                    [0, 0],
                    [9.104, -0.019],
                    [0, 0],
                    [0.019, 9.104]
                  ],
                  "v": [
                    [86.786, 74.858],
                    [-86.469, 75.223],
                    [-103.057, 58.704],
                    [-103.304, -58.271],
                    [-86.786, -74.858],
                    [86.471, -75.223],
                    [103.058, -58.704],
                    [103.303, 58.271]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.845, 105.876], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 9",
          "ix": 9,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.018, 8.298],
                    [0, 0],
                    [8.281, 0],
                    [0, 0],
                    [0, 0],
                    [-0.017, -8.298],
                    [0, 0],
                    [-8.28, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [8.296, -0.018],
                    [0, 0],
                    [-0.018, -8.285],
                    [0, 0],
                    [0, 0],
                    [-8.296, 0.018],
                    [0, 0],
                    [0.018, 8.285],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [86.783, 73.352],
                    [86.786, 74.86],
                    [86.783, 73.352],
                    [101.797, 58.274],
                    [101.552, -58.701],
                    [86.505, -73.715],
                    [86.474, -73.715],
                    [-86.782, -73.352],
                    [-101.797, -58.274],
                    [-101.55, 58.702],
                    [-86.505, 73.715],
                    [-86.472, 73.715]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0.02, 9.946],
                    [0, 0],
                    [-9.958, 0.02],
                    [0, 0],
                    [0, 0],
                    [-0.021, -9.946],
                    [0, 0],
                    [9.958, -0.02],
                    [0, 0]
                  ],
                  "o": [
                    [-9.94, 0],
                    [0, 0],
                    [-0.021, -9.959],
                    [0, 0],
                    [0, 0],
                    [9.94, 0],
                    [0, 0],
                    [0.021, 9.959],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-86.505, 76.73],
                    [-104.563, 58.708],
                    [-104.81, -58.268],
                    [-86.787, -76.365],
                    [86.468, -76.73],
                    [86.505, -76.73],
                    [104.565, -58.708],
                    [104.81, 58.268],
                    [86.789, 76.365],
                    [-86.467, 76.73]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.845, 96.496], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 10",
          "ix": 10,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [9.104, -0.019],
                    [0, 0],
                    [0.019, 9.104],
                    [0, 0],
                    [-9.104, 0.019],
                    [0, 0],
                    [-0.02, -9.104],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-9.105, 0.019],
                    [0, 0],
                    [-0.019, -9.104],
                    [0, 0],
                    [9.104, -0.019],
                    [0, 0],
                    [0.019, 9.104]
                  ],
                  "v": [
                    [86.786, 74.858],
                    [-86.469, 75.223],
                    [-103.057, 58.704],
                    [-103.304, -58.272],
                    [-86.786, -74.858],
                    [86.471, -75.223],
                    [103.058, -58.704],
                    [103.303, 58.271]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.845, 96.496], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 11",
          "ix": 11,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.381]
                  ],
                  "v": [
                    [80.826, 74.871],
                    [-80.511, 75.21],
                    [-103.071, 52.745],
                    [-103.291, -52.312],
                    [-80.826, -74.871],
                    [80.511, -75.21],
                    [103.07, -52.745],
                    [103.291, 52.312]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.845, 87.116], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 12",
          "ix": 12,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [11.148, 0],
                    [0, 0],
                    [0, 0],
                    [-0.022, -11.167],
                    [0, 0],
                    [-3.845, -3.83],
                    [-5.368, 0],
                    [0, 0],
                    [0, 0],
                    [-3.831, 3.844],
                    [0.012, 5.385],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [-11.166, 0.024],
                    [0, 0],
                    [0.012, 5.385],
                    [3.835, 3.819],
                    [0, 0],
                    [0, 0],
                    [5.383, -0.012],
                    [3.829, -3.846],
                    [0, 0],
                    [-0.023, -11.152]
                  ],
                  "v": [
                    [80.557, -72.95],
                    [80.516, -72.95],
                    [-80.822, -72.612],
                    [-101.032, -52.316],
                    [-100.811, 52.741],
                    [-94.83, 67.03],
                    [-80.561, 72.95],
                    [-80.516, 72.95],
                    [80.822, 72.612],
                    [95.111, 66.631],
                    [101.031, 52.317],
                    [100.81, -52.741]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [80.826, 74.872],
                    [80.841, 74.872]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [4.688, 4.668],
                    [0.015, 6.592],
                    [0, 0],
                    [-13.66, 0.029],
                    [0, 0],
                    [0, 0],
                    [-0.029, -13.642],
                    [0, 0],
                    [13.66, -0.029],
                    [0, 0]
                  ],
                  "o": [
                    [-6.572, 0],
                    [-4.7, -4.682],
                    [0, 0],
                    [-0.028, -13.659],
                    [0, 0],
                    [0, 0],
                    [13.636, 0],
                    [0, 0],
                    [0.029, 13.658],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-80.561, 77.47],
                    [-98.019, 70.233],
                    [-105.331, 52.75],
                    [-105.552, -52.307],
                    [-80.831, -77.131],
                    [80.507, -77.47],
                    [80.557, -77.47],
                    [105.33, -52.749],
                    [105.551, 52.308],
                    [80.831, 77.131],
                    [-80.508, 77.47]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.846, 87.116], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 13",
          "ix": 13,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.381]
                  ],
                  "v": [
                    [80.826, 74.871],
                    [-80.511, 75.21],
                    [-103.071, 52.745],
                    [-103.291, -52.312],
                    [-80.826, -74.871],
                    [80.511, -75.21],
                    [103.07, -52.745],
                    [103.291, 52.312]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.846, 87.116], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 14",
          "ix": 14,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [11.148, 0],
                    [0, 0],
                    [0, 0],
                    [-0.022, -11.167],
                    [0, 0],
                    [-3.845, -3.83],
                    [-5.368, 0],
                    [0, 0],
                    [0, 0],
                    [-3.831, 3.844],
                    [0.012, 5.385],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [-11.166, 0.024],
                    [0, 0],
                    [0.012, 5.385],
                    [3.835, 3.819],
                    [0, 0],
                    [0, 0],
                    [5.383, -0.012],
                    [3.829, -3.846],
                    [0, 0],
                    [-0.023, -11.152]
                  ],
                  "v": [
                    [80.557, -72.95],
                    [80.516, -72.95],
                    [-80.822, -72.612],
                    [-101.032, -52.316],
                    [-100.811, 52.741],
                    [-94.83, 67.03],
                    [-80.561, 72.95],
                    [-80.516, 72.95],
                    [80.822, 72.612],
                    [95.111, 66.631],
                    [101.031, 52.317],
                    [100.81, -52.741]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [80.826, 74.872],
                    [80.841, 74.872]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [4.688, 4.668],
                    [0.015, 6.592],
                    [0, 0],
                    [-13.66, 0.029],
                    [0, 0],
                    [0, 0],
                    [-0.029, -13.642],
                    [0, 0],
                    [13.66, -0.029],
                    [0, 0]
                  ],
                  "o": [
                    [-6.572, 0],
                    [-4.7, -4.682],
                    [0, 0],
                    [-0.028, -13.659],
                    [0, 0],
                    [0, 0],
                    [13.636, 0],
                    [0, 0],
                    [0.029, 13.658],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-80.561, 77.47],
                    [-98.019, 70.233],
                    [-105.331, 52.75],
                    [-105.552, -52.307],
                    [-80.831, -77.131],
                    [80.507, -77.47],
                    [80.557, -77.47],
                    [105.33, -52.749],
                    [105.551, 52.308],
                    [80.831, 77.131],
                    [-80.508, 77.47]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.846, 87.116], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 15",
          "ix": 15,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.381]
                  ],
                  "v": [
                    [80.826, 74.871],
                    [-80.511, 75.21],
                    [-103.071, 52.745],
                    [-103.291, -52.312],
                    [-80.826, -74.871],
                    [80.511, -75.21],
                    [103.07, -52.745],
                    [103.291, 52.312]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.2392, 0.5216, 0.9922], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.846, 87.116], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 3
    },
    {
      "ty": 4,
      "nm": "Layer 9 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [19.301, 23.844, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 101.262, 0],
              "t": 0,
              "ti": [0, 0, 0],
              "to": [0, -4.571, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 73.836, 0],
              "t": 45,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 101.262, 0],
              "t": 75,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 73.836, 0],
              "t": 120,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 101.262, 0],
              "t": 150,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 73.836, 0],
              "t": 195,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [107.059, 101.262, 0],
              "t": 225,
              "ti": [0, 4.571, 0],
              "to": [0, 0, 0]
            },
            { "s": [107.059, 73.836, 0], "t": 270 }
          ],
          "ix": 2
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 0 },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 22
            },
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 45 },
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 75 },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 97
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 120
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 172
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 195
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 225
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100],
              "t": 247
            },
            { "s": [0], "t": 270 }
          ],
          "ix": 11
        }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [2.08, 0],
                    [0, 2.08],
                    [0, 0],
                    [-2.08, 0],
                    [0, -2.08],
                    [0, 0]
                  ],
                  "o": [
                    [-2.08, 0],
                    [0, 0],
                    [0, -2.08],
                    [2.08, 0],
                    [0, 0],
                    [0, 2.08]
                  ],
                  "v": [
                    [0, 22.825],
                    [-3.767, 19.059],
                    [-3.767, -19.059],
                    [0, -22.825],
                    [3.767, -19.059],
                    [3.767, 19.059]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [19.308, 24.613], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.953, 0],
                    [0.739, 0.748],
                    [-1.483, 1.46],
                    [0, 0],
                    [0, 0],
                    [1.471, -1.472],
                    [1.471, 1.471],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-0.974, 0],
                    [-1.458, -1.485],
                    [0, 0],
                    [0, 0],
                    [1.471, 1.471],
                    [-1.471, 1.471],
                    [0, 0],
                    [0, 0],
                    [-0.734, 0.721]
                  ],
                  "v": [
                    [-14.906, 11.743],
                    [-17.593, 10.618],
                    [-17.548, 5.291],
                    [0.154, -12.111],
                    [17.581, 5.314],
                    [17.581, 10.64],
                    [12.255, 10.64],
                    [0.111, -1.503],
                    [-12.265, 10.663]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [19.301, 12.362], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 4,
      "parent": 5
    },
    {
      "ty": 4,
      "nm": "Layer 4 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [105.83, 95.55, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [334.844, 728.662, 0],
              "t": 0,
              "ti": [-3.333, 0, 0],
              "to": [-3.333, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [314.844, 728.662, 0],
              "t": 5,
              "ti": [-3.333, 0, 0],
              "to": [3.333, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [354.844, 728.662, 0],
              "t": 10,
              "ti": [3.333, 0, 0],
              "to": [3.333, 0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [334.844, 728.662, 0],
              "t": 14,
              "ti": [0, 0, 0],
              "to": [0, 0, 0]
            },
            { "s": [334.844, 728.662, 0], "t": 19 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 0 },
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [4], "t": 5 },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [-3],
              "t": 10
            },
            { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [2], "t": 14 },
            { "s": [0], "t": 19 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [4.708, 0],
                    [0, 0],
                    [0, 4.465],
                    [0, 0],
                    [-2.08, 0],
                    [0, -2.081],
                    [0, 0],
                    [-0.312, 0],
                    [0, 0],
                    [0, 0.555],
                    [0, 0],
                    [-2.08, 0],
                    [0, -2.081],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-4.465, 0],
                    [0, 0],
                    [0, -2.081],
                    [2.08, 0],
                    [0, 0],
                    [0, 0.311],
                    [0, 0],
                    [0.555, 0],
                    [0, 0],
                    [0, -2.081],
                    [2.081, 0],
                    [0, 0],
                    [0, 4.708]
                  ],
                  "v": [
                    [27.73, 16.087],
                    [-28.169, 16.087],
                    [-36.268, 7.988],
                    [-36.268, -12.32],
                    [-32.502, -16.087],
                    [-28.736, -12.32],
                    [-28.736, 7.988],
                    [-28.169, 8.554],
                    [27.73, 8.554],
                    [28.734, 7.549],
                    [28.734, -12.32],
                    [32.501, -16.087],
                    [36.268, -12.32],
                    [36.268, 7.549]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [107.09, 126.99], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.833, 0],
                    [0, 0.833],
                    [0, 0],
                    [3.665, 0],
                    [0, 0],
                    [0, 0.833],
                    [-0.833, 0],
                    [0, 0],
                    [0, -5.022],
                    [0, 0]
                  ],
                  "o": [
                    [-0.833, 0],
                    [0, 0],
                    [0, -3.361],
                    [0, 0],
                    [-0.833, 0],
                    [0, -0.832],
                    [0, 0],
                    [5.326, 0],
                    [0, 0],
                    [0, 0.833]
                  ],
                  "v": [
                    [11.372, 15.319],
                    [9.864, 13.813],
                    [9.864, -6.212],
                    [3.219, -12.306],
                    [-11.372, -12.306],
                    [-12.878, -13.814],
                    [-11.372, -15.319],
                    [3.219, -15.319],
                    [12.878, -6.212],
                    [12.878, 13.813]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [188.571, 26.912], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -4.063],
                    [4.063, 0],
                    [0, 4.063],
                    [-4.062, 0]
                  ],
                  "o": [
                    [0, 4.063],
                    [-4.062, 0],
                    [0, -4.063],
                    [4.063, 0]
                  ],
                  "v": [
                    [7.357, 0],
                    [-0.001, 7.356],
                    [-7.357, 0],
                    [-0.001, -7.356]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [187.445, 166.588], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [7.25, -0.015],
                    [0, 0],
                    [-0.015, -7.251],
                    [0, 0],
                    [0, 0],
                    [-0.023, -11.081],
                    [0, 0],
                    [-11.079, 0.024],
                    [0, 0],
                    [0.024, 11.081],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-7.25, 0.015],
                    [0, 0],
                    [0, 0],
                    [-11.078, 0.023],
                    [0, 0],
                    [0.023, 11.081],
                    [0, 0],
                    [11.078, -0.023],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.015, -7.252]
                  ],
                  "v": [
                    [78.931, -83.265],
                    [39.831, -83.183],
                    [26.676, -69.971],
                    [26.716, -51.256],
                    [-72.32, -51.048],
                    [-92.42, -30.859],
                    [-92.222, 63.16],
                    [-72.037, 83.264],
                    [72.319, 82.961],
                    [92.419, 62.772],
                    [92.226, -29.321],
                    [92.222, -31.247],
                    [92.14, -70.108]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.3725, 0.6078, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [113.597, 102.531], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [88.216, -93.041],
                    [88.231, -93.041]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [2.359, -2.369],
                    [-0.007, -3.315],
                    [0, 0],
                    [0.424, -0.426],
                    [0.6, -0.002],
                    [0, 0],
                    [-0.023, -11.167],
                    [0, 0],
                    [-11.147, 0],
                    [0, 0],
                    [0, 0],
                    [0.022, 11.169],
                    [0, 0],
                    [6.865, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-3.315, 0.008],
                    [-2.359, 2.369],
                    [0, 0],
                    [0.002, 0.599],
                    [-0.422, 0.423],
                    [0, 0],
                    [-11.167, 0.024],
                    [0, 0],
                    [0.023, 11.153],
                    [0, 0],
                    [0, 0],
                    [11.165, -0.022],
                    [0, 0],
                    [-0.014, -6.867],
                    [0, 0]
                  ],
                  "v": [
                    [88.22, -90.781],
                    [44.521, -90.689],
                    [35.722, -87.006],
                    [32.075, -78.191],
                    [32.119, -57.278],
                    [31.46, -55.679],
                    [29.864, -55.014],
                    [-80.821, -54.782],
                    [-101.031, -34.486],
                    [-100.81, 70.57],
                    [-80.557, 90.781],
                    [-80.515, 90.781],
                    [80.823, 90.441],
                    [101.032, 70.145],
                    [100.72, -78.335],
                    [88.248, -90.781]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0.03, 13.642],
                    [0, 0],
                    [-13.661, 0.03],
                    [0, 0],
                    [0, 0],
                    [-3.211, 3.223],
                    [-4.523, 0.011],
                    [0, 0],
                    [0, 0],
                    [-0.021, -9.359],
                    [0, 0],
                    [13.658, -0.028],
                    [0, 0]
                  ],
                  "o": [
                    [-13.635, 0],
                    [0, 0],
                    [-0.029, -13.658],
                    [0, 0],
                    [0, 0],
                    [-0.01, -4.521],
                    [3.21, -3.225],
                    [0, 0],
                    [0, 0],
                    [9.353, 0],
                    [0, 0],
                    [0.028, 13.66],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-80.557, 95.3],
                    [-105.33, 70.579],
                    [-105.551, -34.477],
                    [-80.83, -59.301],
                    [27.595, -59.529],
                    [27.555, -78.183],
                    [32.52, -90.193],
                    [44.512, -95.209],
                    [88.212, -95.3],
                    [88.248, -95.3],
                    [105.24, -78.343],
                    [105.552, 70.136],
                    [80.832, 94.96],
                    [-80.507, 95.3]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.83, 95.55], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [8.103, -0.017],
                    [0, 0],
                    [-0.017, -8.103],
                    [0, 0],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-8.103, 0.017],
                    [0, 0],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [0.026, 12.381],
                    [0, 0],
                    [12.382, -0.026],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.017, -8.102]
                  ],
                  "v": [
                    [88.216, -93.045],
                    [44.516, -92.952],
                    [29.815, -78.189],
                    [29.859, -57.278],
                    [-80.826, -57.045],
                    [-103.291, -34.485],
                    [-103.071, 70.571],
                    [-80.511, 93.036],
                    [80.826, 92.697],
                    [103.291, 70.137],
                    [103.075, -32.768],
                    [103.07, -34.92],
                    [102.979, -78.343]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.2392, 0.5216, 0.9922], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.83, 95.554], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [8.282, 0],
                    [0, 0],
                    [0, 0],
                    [2.844, -2.858],
                    [-0.009, -4],
                    [0, 0],
                    [-2.857, -2.846],
                    [-3.989, 0],
                    [0, 0],
                    [0, 0],
                    [0.018, 8.297],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [-4, 0.009],
                    [-2.846, 2.857],
                    [0, 0],
                    [0.008, 4],
                    [2.85, 2.838],
                    [0, 0],
                    [0, 0],
                    [8.296, -0.018],
                    [0, 0],
                    [-0.018, -8.284]
                  ],
                  "v": [
                    [86.5, -73.716],
                    [86.468, -73.716],
                    [-86.788, -73.353],
                    [-97.403, -68.909],
                    [-101.802, -58.275],
                    [-101.556, 58.7],
                    [-97.113, 69.317],
                    [-86.511, 73.716],
                    [-86.479, 73.716],
                    [86.777, 73.351],
                    [101.792, 58.273],
                    [101.547, -58.702]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [3.419, 3.404],
                    [0.011, 4.805],
                    [0, 0],
                    [-3.413, 3.426],
                    [-4.805, 0.01],
                    [0, 0],
                    [0, 0],
                    [-0.021, -9.945],
                    [0, 0],
                    [9.959, -0.021],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-4.791, 0],
                    [-3.427, -3.414],
                    [0, 0],
                    [-0.011, -4.805],
                    [3.412, -3.428],
                    [0, 0],
                    [0, 0],
                    [9.941, 0],
                    [0, 0],
                    [0.02, 9.958],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-86.511, 76.729],
                    [-99.239, 71.452],
                    [-104.57, 58.706],
                    [-104.815, -58.269],
                    [-99.538, -71.035],
                    [-86.794, -76.366],
                    [86.462, -76.729],
                    [86.5, -76.729],
                    [104.56, -58.708],
                    [104.806, 58.267],
                    [86.783, 76.364],
                    [86.78, 74.857],
                    [86.783, 76.364],
                    [-86.473, 76.729]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.851, 105.877], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 8",
          "ix": 8,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [9.104, -0.019],
                    [0, 0],
                    [0.019, 9.104],
                    [0, 0],
                    [-9.104, 0.019],
                    [0, 0],
                    [-0.02, -9.104],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-9.104, 0.019],
                    [0, 0],
                    [-0.019, -9.105],
                    [0, 0],
                    [9.104, -0.019],
                    [0, 0],
                    [0.019, 9.104]
                  ],
                  "v": [
                    [86.786, 74.858],
                    [-86.47, 75.223],
                    [-103.057, 58.704],
                    [-103.303, -58.271],
                    [-86.785, -74.858],
                    [86.471, -75.223],
                    [103.058, -58.704],
                    [103.303, 58.271]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.846, 105.876], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 5
    },
    {
      "ty": 4,
      "nm": "Layer 11 Outlines 2",
      "sr": 1,
      "st": 139,
      "op": 439,
      "ip": 139,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [63.201, 77.748, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [71.076, 71.076, 100],
              "t": 139
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 199.201
            },
            { "s": [67.078, 67.078, 100], "t": 259 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [321.137, 729.512, 0],
              "t": 139,
              "ti": [-13, -487.333, 0],
              "to": [-73, -418.667, 0]
            },
            { "s": [747.137, 725.512, 0], "t": 259 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [-360], "t": 139 },
            { "s": [0], "t": 259 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.078, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.839, -0.126],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.822, -0.123],
                    [0.124, -0.823],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.111, 0.746]
                  ],
                  "v": [
                    [20.603, 4.685],
                    [20.374, 4.668],
                    [-20.828, -1.582],
                    [-22.09, -3.297],
                    [-20.374, -4.56],
                    [20.827, 1.69],
                    [22.09, 3.405]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [40.775, 117.451], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.826, -0.127],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.823, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [36.637, 7.119],
                    [36.408, 7.101],
                    [-36.861, -4.014],
                    [-38.124, -5.73],
                    [-36.408, -6.992],
                    [36.861, 4.123],
                    [38.124, 5.839]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [60.589, 94.971], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.823],
                    [-0.825, -0.128],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.823, -0.124],
                    [0.126, -0.823],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [20.872, 4.728],
                    [20.644, 4.71],
                    [-21.096, -1.622],
                    [-22.359, -3.337],
                    [-20.643, -4.6],
                    [21.097, 1.732],
                    [22.359, 3.448]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [48.38, 69.133], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.828, -0.13],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.822, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [18.319, 4.342],
                    [18.091, 4.324],
                    [-18.544, -1.234],
                    [-19.806, -2.95],
                    [-18.091, -4.212],
                    [18.544, 1.346],
                    [19.806, 3.062]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [49.608, 43.833], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.826, -0.128],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.822, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [10.727, 3.189],
                    [10.498, 3.171],
                    [-10.952, -0.083],
                    [-12.214, -1.799],
                    [-10.499, -3.061],
                    [10.951, 0.193],
                    [12.214, 1.909]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [93.835, 50.543], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.821, -0.131],
                    [0, 0],
                    [0.126, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.823, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [9.341, 2.98],
                    [9.113, 2.962],
                    [-9.566, 0.129],
                    [-10.829, -1.587],
                    [-9.113, -2.849],
                    [9.566, -0.016],
                    [10.828, 1.7]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.729, 23.157], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-58.264, 58.268],
                    [38.378, 72.932],
                    [58.265, -58.149],
                    [-38.378, -72.812]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.886, 0],
                    [0.212, 0.033],
                    [0, 0],
                    [0.662, 0.901],
                    [-0.169, 1.107],
                    [0, 0],
                    [-0.901, 0.662],
                    [-1.103, -0.166],
                    [0, 0],
                    [-0.663, -0.901],
                    [0.166, -1.105],
                    [0, 0],
                    [0.9, -0.662]
                  ],
                  "o": [
                    [-0.211, 0],
                    [0, 0],
                    [-1.105, -0.167],
                    [-0.663, -0.901],
                    [0, 0],
                    [0.168, -1.105],
                    [0.899, -0.662],
                    [0, 0],
                    [1.105, 0.168],
                    [0.663, 0.9],
                    [0, 0],
                    [-0.167, 1.105],
                    [-0.727, 0.535]
                  ],
                  "v": [
                    [38.668, 77.497],
                    [38.032, 77.45],
                    [-59.273, 62.687],
                    [-62.016, 61.031],
                    [-62.782, 57.919],
                    [-42.797, -73.82],
                    [-41.141, -76.562],
                    [-38.033, -77.332],
                    [59.274, -62.568],
                    [62.016, -60.912],
                    [62.785, -57.804],
                    [42.796, 73.941],
                    [41.141, 76.682]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [63.201, 77.748], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 8",
          "ix": 8,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.051, 0.159],
                    [0, 0],
                    [-0.16, 1.05],
                    [0, 0],
                    [-1.051, -0.16],
                    [0, 0],
                    [0.159, -1.051],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.051, -0.16],
                    [0, 0],
                    [0.159, -1.051],
                    [0, 0],
                    [1.051, 0.16],
                    [0, 0],
                    [-0.159, 1.051]
                  ],
                  "v": [
                    [38.371, 75.156],
                    [-58.935, 60.393],
                    [-60.549, 58.202],
                    [-40.561, -73.541],
                    [-38.37, -75.155],
                    [58.936, -60.392],
                    [60.55, -58.201],
                    [40.562, 73.542]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [63.201, 77.807], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 6
    },
    {
      "ty": 4,
      "nm": "Layer 11 Outlines",
      "sr": 1,
      "st": 31,
      "op": 331,
      "ip": 31,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [63.201, 77.748, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [71.076, 71.076, 100],
              "t": 31
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 91.201
            },
            { "s": [67.078, 67.078, 100], "t": 151 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [321.137, 729.512, 0],
              "t": 31,
              "ti": [-13, -487.333, 0],
              "to": [-73, -418.667, 0]
            },
            { "s": [747.137, 725.512, 0], "t": 151 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [-360], "t": 31 },
            { "s": [0], "t": 151 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.078, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.839, -0.126],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.822, -0.123],
                    [0.124, -0.823],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.111, 0.746]
                  ],
                  "v": [
                    [20.603, 4.685],
                    [20.374, 4.668],
                    [-20.828, -1.582],
                    [-22.09, -3.297],
                    [-20.374, -4.56],
                    [20.827, 1.69],
                    [22.09, 3.405]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [40.775, 117.451], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.826, -0.127],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.823, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [36.637, 7.119],
                    [36.408, 7.101],
                    [-36.861, -4.014],
                    [-38.124, -5.73],
                    [-36.408, -6.992],
                    [36.861, 4.123],
                    [38.124, 5.839]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [60.589, 94.971], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.823],
                    [-0.825, -0.128],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.823, -0.124],
                    [0.126, -0.823],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [20.872, 4.728],
                    [20.644, 4.71],
                    [-21.096, -1.622],
                    [-22.359, -3.337],
                    [-20.643, -4.6],
                    [21.097, 1.732],
                    [22.359, 3.448]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [48.38, 69.133], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.828, -0.13],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.822, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [18.319, 4.342],
                    [18.091, 4.324],
                    [-18.544, -1.234],
                    [-19.806, -2.95],
                    [-18.091, -4.212],
                    [18.544, 1.346],
                    [19.806, 3.062]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [49.608, 43.833], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.826, -0.128],
                    [0, 0],
                    [0.125, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.822, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [10.727, 3.189],
                    [10.498, 3.171],
                    [-10.952, -0.083],
                    [-12.214, -1.799],
                    [-10.499, -3.061],
                    [10.951, 0.193],
                    [12.214, 1.909]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [93.835, 50.543], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.733, 0],
                    [0.076, 0.012],
                    [0, 0],
                    [-0.125, 0.824],
                    [-0.821, -0.131],
                    [0, 0],
                    [0.126, -0.824]
                  ],
                  "o": [
                    [-0.075, 0],
                    [0, 0],
                    [-0.823, -0.124],
                    [0.125, -0.822],
                    [0, 0],
                    [0.823, 0.124],
                    [-0.113, 0.746]
                  ],
                  "v": [
                    [9.341, 2.98],
                    [9.113, 2.962],
                    [-9.566, 0.129],
                    [-10.829, -1.587],
                    [-9.113, -2.849],
                    [9.566, -0.016],
                    [10.828, 1.7]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.729, 23.157], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-58.264, 58.268],
                    [38.378, 72.932],
                    [58.265, -58.149],
                    [-38.378, -72.812]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.886, 0],
                    [0.212, 0.033],
                    [0, 0],
                    [0.662, 0.901],
                    [-0.169, 1.107],
                    [0, 0],
                    [-0.901, 0.662],
                    [-1.103, -0.166],
                    [0, 0],
                    [-0.663, -0.901],
                    [0.166, -1.105],
                    [0, 0],
                    [0.9, -0.662]
                  ],
                  "o": [
                    [-0.211, 0],
                    [0, 0],
                    [-1.105, -0.167],
                    [-0.663, -0.901],
                    [0, 0],
                    [0.168, -1.105],
                    [0.899, -0.662],
                    [0, 0],
                    [1.105, 0.168],
                    [0.663, 0.9],
                    [0, 0],
                    [-0.167, 1.105],
                    [-0.727, 0.535]
                  ],
                  "v": [
                    [38.668, 77.497],
                    [38.032, 77.45],
                    [-59.273, 62.687],
                    [-62.016, 61.031],
                    [-62.782, 57.919],
                    [-42.797, -73.82],
                    [-41.141, -76.562],
                    [-38.033, -77.332],
                    [59.274, -62.568],
                    [62.016, -60.912],
                    [62.785, -57.804],
                    [42.796, 73.941],
                    [41.141, 76.682]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [63.201, 77.748], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 8",
          "ix": 8,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.051, 0.159],
                    [0, 0],
                    [-0.16, 1.05],
                    [0, 0],
                    [-1.051, -0.16],
                    [0, 0],
                    [0.159, -1.051],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.051, -0.16],
                    [0, 0],
                    [0.159, -1.051],
                    [0, 0],
                    [1.051, 0.16],
                    [0, 0],
                    [-0.159, 1.051]
                  ],
                  "v": [
                    [38.371, 75.156],
                    [-58.935, 60.393],
                    [-60.549, 58.202],
                    [-40.561, -73.541],
                    [-38.37, -75.155],
                    [58.936, -60.392],
                    [60.55, -58.201],
                    [40.562, 73.542]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [63.201, 77.807], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 7
    },
    {
      "ty": 4,
      "nm": "Layer 12 Outlines 5",
      "sr": 1,
      "st": 83,
      "op": 383,
      "ip": 83,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [53.907, 53.907, 100],
              "t": 83
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 143.201
            },
            { "s": [66.459, 66.459, 100], "t": 203 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [318.45, 739.698, 0],
              "t": 83,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 203 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [360], "t": 83 },
            { "s": [0], "t": 203 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-1.238, -1.261],
                    [1.262, -1.237],
                    [1.238, 1.261],
                    [-1.262, 1.238]
                  ],
                  "o": [
                    [1.238, 1.261],
                    [-1.261, 1.238],
                    [-1.238, -1.262],
                    [1.261, -1.238]
                  ],
                  "v": [
                    [2.284, -2.241],
                    [2.241, 2.284],
                    [-2.284, 2.242],
                    [-2.241, -2.284]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [54.56, 25.871], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.48, 0],
                    [0.424, 0.168],
                    [0.378, 0.874],
                    [0, 0],
                    [-0.381, 0.166],
                    [-0.166, -0.381],
                    [0, 0],
                    [-0.51, -0.201],
                    [-0.502, 0.218],
                    [0, 0],
                    [0.349, 0.803],
                    [0, 0],
                    [0.831, -0.356],
                    [0, 0],
                    [-0.382, -0.882],
                    [0, 0],
                    [0.381, -0.166],
                    [0.166, 0.383],
                    [0, 0],
                    [-1.645, 0.712],
                    [0, 0],
                    [-0.69, -1.59],
                    [0, 0],
                    [1.566, -0.68],
                    [0, 0]
                  ],
                  "o": [
                    [-0.443, 0],
                    [-0.886, -0.35],
                    [0, 0],
                    [-0.165, -0.383],
                    [0.384, -0.166],
                    [0, 0],
                    [0.218, 0.504],
                    [0.515, 0.205],
                    [0, 0],
                    [0.804, -0.349],
                    [0, 0],
                    [-0.359, -0.829],
                    [0, 0],
                    [-0.883, 0.381],
                    [0, 0],
                    [0.166, 0.383],
                    [-0.378, 0.168],
                    [0, 0],
                    [-0.714, -1.648],
                    [0, 0],
                    [1.587, -0.686],
                    [0, 0],
                    [0.677, 1.565],
                    [0, 0],
                    [-0.453, 0.197]
                  ],
                  "v": [
                    [2.373, 9.217],
                    [1.062, 8.965],
                    [-0.898, 7.067],
                    [-2.884, 2.486],
                    [-2.493, 1.494],
                    [-1.501, 1.886],
                    [0.485, 6.469],
                    [1.615, 7.563],
                    [3.188, 7.538],
                    [3.523, 7.394],
                    [4.349, 5.305],
                    [-0.677, -6.295],
                    [-2.835, -7.148],
                    [-3.406, -6.899],
                    [-4.314, -4.606],
                    [-4.19, -4.322],
                    [-4.579, -3.33],
                    [-5.57, -3.719],
                    [-5.695, -4.005],
                    [-4.005, -8.282],
                    [-3.434, -8.531],
                    [0.706, -6.895],
                    [5.732, 4.706],
                    [4.122, 8.777],
                    [3.787, 8.921]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [33.101, 31.531], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [27.882, 14.726],
                    [27.897, 14.726]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.586, 0],
                    [0.195, -0.084],
                    [0, 0],
                    [0.149, -0.377],
                    [-0.16, -0.371],
                    [0, 0],
                    [-0.377, -0.149],
                    [-0.374, 0.158],
                    [0, 0],
                    [-0.149, 0.375],
                    [0.161, 0.371],
                    [0, 0]
                  ],
                  "o": [
                    [-0.2, 0],
                    [0, 0],
                    [-0.371, 0.161],
                    [-0.149, 0.375],
                    [0, 0],
                    [0.16, 0.371],
                    [0.374, 0.15],
                    [0, 0],
                    [0.371, -0.16],
                    [0.149, -0.376],
                    [0, 0],
                    [-0.248, -0.569]
                  ],
                  "v": [
                    [9.747, -28.637],
                    [9.147, -28.515],
                    [-27.283, -12.73],
                    [-28.088, -11.898],
                    [-28.071, -10.739],
                    [-11.136, 28.342],
                    [-10.305, 29.146],
                    [-9.147, 29.128],
                    [27.283, 13.343],
                    [28.088, 12.512],
                    [28.07, 11.355],
                    [11.138, -27.727]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.61, 0],
                    [0.539, 0.213],
                    [0.481, 1.109],
                    [0, 0],
                    [-0.444, 1.124],
                    [-1.109, 0.481],
                    [0, 0],
                    [-0.992, -2.292],
                    [0, 0],
                    [0.444, -1.124],
                    [1.109, -0.48],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-0.564, 0],
                    [-1.125, -0.445],
                    [0, 0],
                    [-0.48, -1.109],
                    [0.444, -1.126],
                    [0, 0],
                    [2.29, -0.99],
                    [0, 0],
                    [0.479, 1.11],
                    [-0.444, 1.124],
                    [0, 0],
                    [0, 0],
                    [-0.577, 0.25]
                  ],
                  "v": [
                    [-9.747, 32.269],
                    [-11.413, 31.95],
                    [-13.902, 29.54],
                    [-30.835, -9.542],
                    [-30.891, -13.006],
                    [-28.481, -15.494],
                    [7.949, -31.278],
                    [13.902, -28.925],
                    [30.835, 10.157],
                    [30.891, 13.62],
                    [28.481, 16.109],
                    [28.481, 16.11],
                    [-7.949, 31.894]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.445, 46.724], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.53, -0.663],
                    [0, 0],
                    [0.663, 1.53],
                    [0, 0],
                    [-1.53, 0.663],
                    [0, 0],
                    [-0.664, -1.53],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.53, 0.663],
                    [0, 0],
                    [-0.663, -1.531],
                    [0, 0],
                    [1.531, -0.663],
                    [0, 0],
                    [0.663, 1.53]
                  ],
                  "v": [
                    [27.882, 14.419],
                    [-8.549, 30.204],
                    [-12.52, 28.633],
                    [-29.452, -10.447],
                    [-27.882, -14.42],
                    [8.548, -30.204],
                    [12.52, -28.633],
                    [29.452, 10.449]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.446, 47.031], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.314],
                    [0, 0],
                    [-0.315, -0.773],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.764, -0.316],
                    [0.314, 0.769],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-21.127, 10.24],
                    [-22.522, 9.303],
                    [-21.696, 7.339],
                    [20.558, -9.924],
                    [22.523, -9.098],
                    [21.697, -7.134],
                    [-20.558, 10.128]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [71.61, 119.104], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.314],
                    [0, 0],
                    [-0.315, -0.771],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.764, -0.316],
                    [0.315, 0.769],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-8.345, 5.018],
                    [-9.74, 4.082],
                    [-8.914, 2.118],
                    [7.777, -4.702],
                    [9.741, -3.876],
                    [8.916, -1.913],
                    [-7.777, 4.906]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [53.443, 105.821], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.315],
                    [0, 0],
                    [-0.315, -0.771],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.768, -0.318],
                    [0.315, 0.77],
                    [0, 0],
                    [-0.186, 0.077]
                  ],
                  "v": [
                    [-13.634, 7.179],
                    [-15.029, 6.242],
                    [-14.203, 4.278],
                    [13.065, -6.861],
                    [15.029, -6.036],
                    [14.204, -4.072],
                    [-13.065, 7.067]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [100.067, 86.774], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 8",
          "ix": 8,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.314],
                    [0, 0],
                    [-0.315, -0.773],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.764, -0.317],
                    [0.315, 0.769],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-34.301, 15.622],
                    [-35.696, 14.686],
                    [-34.87, 12.722],
                    [33.732, -15.305],
                    [35.696, -14.479],
                    [34.871, -12.516],
                    [-33.732, 15.51]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [72.916, 79.347], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 9",
          "ix": 9,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.315],
                    [0, 0],
                    [-0.316, -0.77],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.762, -0.316],
                    [0.315, 0.77],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-7.833, 4.809],
                    [-9.229, 3.873],
                    [-8.402, 1.909],
                    [7.265, -4.493],
                    [9.229, -3.669],
                    [8.404, -1.703],
                    [-7.265, 4.697]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [89.856, 45.21], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 10",
          "ix": 10,
          "cix": 2,
          "np": 7,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [70.399, 43.036],
                    [70.396, 43.036],
                    [70.399, 43.035]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [71.255, 45.127],
                    [71.269, 45.127]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-70.538, -42.605],
                    [-20.398, 80.128],
                    [70.092, 43.161],
                    [19.95, -79.572]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 4",
              "ix": 4,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.536, 0],
                    [0.521, 0.219],
                    [0.422, 1.035],
                    [0, 0],
                    [-0.433, 1.031],
                    [-1.035, 0.422],
                    [0, 0],
                    [-0.872, -2.134],
                    [0, 0],
                    [2.134, -0.874],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-0.548, 0],
                    [-1.032, -0.433],
                    [0, 0],
                    [-0.424, -1.033],
                    [0.432, -1.031],
                    [0, 0],
                    [2.142, -0.87],
                    [0, 0],
                    [0.871, 2.135],
                    [0, 0.002],
                    [0, 0],
                    [-0.51, 0.209]
                  ],
                  "v": [
                    [-20.583, 84.753],
                    [-22.202, 84.423],
                    [-24.456, 82.148],
                    [-74.848, -41.206],
                    [-74.833, -44.409],
                    [-72.557, -46.663],
                    [18.553, -83.883],
                    [24.007, -81.592],
                    [74.402, 41.762],
                    [72.111, 47.217],
                    [72.11, 47.219],
                    [-19.001, 84.439]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [75.522, 85.003], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 11",
          "ix": 11,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.984, -0.402],
                    [0, 0],
                    [0.402, 0.984],
                    [0, 0],
                    [-0.983, 0.402],
                    [0, 0],
                    [-0.402, -0.984],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.984, 0.402],
                    [0, 0],
                    [-0.402, -0.984],
                    [0, 0],
                    [0.984, -0.402],
                    [0, 0],
                    [0.402, 0.984]
                  ],
                  "v": [
                    [71.479, 44.848],
                    [-19.631, 82.068],
                    [-22.141, 81.016],
                    [-72.533, -42.339],
                    [-71.48, -44.849],
                    [19.631, -82.069],
                    [22.14, -81.014],
                    [72.533, 42.34]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [75.299, 85.281], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 8
    },
    {
      "ty": 4,
      "nm": "Layer 12 Outlines 2",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [53.907, 53.907, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 60.201
            },
            { "s": [66.459, 66.459, 100], "t": 120 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [318.45, 739.698, 0],
              "t": 0,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 120 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [360], "t": 0 },
            { "s": [0], "t": 120 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-1.238, -1.261],
                    [1.262, -1.237],
                    [1.238, 1.261],
                    [-1.262, 1.238]
                  ],
                  "o": [
                    [1.238, 1.261],
                    [-1.261, 1.238],
                    [-1.238, -1.262],
                    [1.261, -1.238]
                  ],
                  "v": [
                    [2.284, -2.241],
                    [2.241, 2.284],
                    [-2.284, 2.242],
                    [-2.241, -2.284]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [54.56, 25.871], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.48, 0],
                    [0.424, 0.168],
                    [0.378, 0.874],
                    [0, 0],
                    [-0.381, 0.166],
                    [-0.166, -0.381],
                    [0, 0],
                    [-0.51, -0.201],
                    [-0.502, 0.218],
                    [0, 0],
                    [0.349, 0.803],
                    [0, 0],
                    [0.831, -0.356],
                    [0, 0],
                    [-0.382, -0.882],
                    [0, 0],
                    [0.381, -0.166],
                    [0.166, 0.383],
                    [0, 0],
                    [-1.645, 0.712],
                    [0, 0],
                    [-0.69, -1.59],
                    [0, 0],
                    [1.566, -0.68],
                    [0, 0]
                  ],
                  "o": [
                    [-0.443, 0],
                    [-0.886, -0.35],
                    [0, 0],
                    [-0.165, -0.383],
                    [0.384, -0.166],
                    [0, 0],
                    [0.218, 0.504],
                    [0.515, 0.205],
                    [0, 0],
                    [0.804, -0.349],
                    [0, 0],
                    [-0.359, -0.829],
                    [0, 0],
                    [-0.883, 0.381],
                    [0, 0],
                    [0.166, 0.383],
                    [-0.378, 0.168],
                    [0, 0],
                    [-0.714, -1.648],
                    [0, 0],
                    [1.587, -0.686],
                    [0, 0],
                    [0.677, 1.565],
                    [0, 0],
                    [-0.453, 0.197]
                  ],
                  "v": [
                    [2.373, 9.217],
                    [1.062, 8.965],
                    [-0.898, 7.067],
                    [-2.884, 2.486],
                    [-2.493, 1.494],
                    [-1.501, 1.886],
                    [0.485, 6.469],
                    [1.615, 7.563],
                    [3.188, 7.538],
                    [3.523, 7.394],
                    [4.349, 5.305],
                    [-0.677, -6.295],
                    [-2.835, -7.148],
                    [-3.406, -6.899],
                    [-4.314, -4.606],
                    [-4.19, -4.322],
                    [-4.579, -3.33],
                    [-5.57, -3.719],
                    [-5.695, -4.005],
                    [-4.005, -8.282],
                    [-3.434, -8.531],
                    [0.706, -6.895],
                    [5.732, 4.706],
                    [4.122, 8.777],
                    [3.787, 8.921]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [33.101, 31.531], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [27.882, 14.726],
                    [27.897, 14.726]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.586, 0],
                    [0.195, -0.084],
                    [0, 0],
                    [0.149, -0.377],
                    [-0.16, -0.371],
                    [0, 0],
                    [-0.377, -0.149],
                    [-0.374, 0.158],
                    [0, 0],
                    [-0.149, 0.375],
                    [0.161, 0.371],
                    [0, 0]
                  ],
                  "o": [
                    [-0.2, 0],
                    [0, 0],
                    [-0.371, 0.161],
                    [-0.149, 0.375],
                    [0, 0],
                    [0.16, 0.371],
                    [0.374, 0.15],
                    [0, 0],
                    [0.371, -0.16],
                    [0.149, -0.376],
                    [0, 0],
                    [-0.248, -0.569]
                  ],
                  "v": [
                    [9.747, -28.637],
                    [9.147, -28.515],
                    [-27.283, -12.73],
                    [-28.088, -11.898],
                    [-28.071, -10.739],
                    [-11.136, 28.342],
                    [-10.305, 29.146],
                    [-9.147, 29.128],
                    [27.283, 13.343],
                    [28.088, 12.512],
                    [28.07, 11.355],
                    [11.138, -27.727]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.61, 0],
                    [0.539, 0.213],
                    [0.481, 1.109],
                    [0, 0],
                    [-0.444, 1.124],
                    [-1.109, 0.481],
                    [0, 0],
                    [-0.992, -2.292],
                    [0, 0],
                    [0.444, -1.124],
                    [1.109, -0.48],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-0.564, 0],
                    [-1.125, -0.445],
                    [0, 0],
                    [-0.48, -1.109],
                    [0.444, -1.126],
                    [0, 0],
                    [2.29, -0.99],
                    [0, 0],
                    [0.479, 1.11],
                    [-0.444, 1.124],
                    [0, 0],
                    [0, 0],
                    [-0.577, 0.25]
                  ],
                  "v": [
                    [-9.747, 32.269],
                    [-11.413, 31.95],
                    [-13.902, 29.54],
                    [-30.835, -9.542],
                    [-30.891, -13.006],
                    [-28.481, -15.494],
                    [7.949, -31.278],
                    [13.902, -28.925],
                    [30.835, 10.157],
                    [30.891, 13.62],
                    [28.481, 16.109],
                    [28.481, 16.11],
                    [-7.949, 31.894]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.445, 46.724], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.53, -0.663],
                    [0, 0],
                    [0.663, 1.53],
                    [0, 0],
                    [-1.53, 0.663],
                    [0, 0],
                    [-0.664, -1.53],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.53, 0.663],
                    [0, 0],
                    [-0.663, -1.531],
                    [0, 0],
                    [1.531, -0.663],
                    [0, 0],
                    [0.663, 1.53]
                  ],
                  "v": [
                    [27.882, 14.419],
                    [-8.549, 30.204],
                    [-12.52, 28.633],
                    [-29.452, -10.447],
                    [-27.882, -14.42],
                    [8.548, -30.204],
                    [12.52, -28.633],
                    [29.452, 10.449]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.446, 47.031], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.314],
                    [0, 0],
                    [-0.315, -0.773],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.764, -0.316],
                    [0.314, 0.769],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-21.127, 10.24],
                    [-22.522, 9.303],
                    [-21.696, 7.339],
                    [20.558, -9.924],
                    [22.523, -9.098],
                    [21.697, -7.134],
                    [-20.558, 10.128]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [71.61, 119.104], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.314],
                    [0, 0],
                    [-0.315, -0.771],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.764, -0.316],
                    [0.315, 0.769],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-8.345, 5.018],
                    [-9.74, 4.082],
                    [-8.914, 2.118],
                    [7.777, -4.702],
                    [9.741, -3.876],
                    [8.916, -1.913],
                    [-7.777, 4.906]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [53.443, 105.821], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.315],
                    [0, 0],
                    [-0.315, -0.771],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.768, -0.318],
                    [0.315, 0.77],
                    [0, 0],
                    [-0.186, 0.077]
                  ],
                  "v": [
                    [-13.634, 7.179],
                    [-15.029, 6.242],
                    [-14.203, 4.278],
                    [13.065, -6.861],
                    [15.029, -6.036],
                    [14.204, -4.072],
                    [-13.065, 7.067]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [100.067, 86.774], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 8",
          "ix": 8,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.314],
                    [0, 0],
                    [-0.315, -0.773],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.764, -0.317],
                    [0.315, 0.769],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-34.301, 15.622],
                    [-35.696, 14.686],
                    [-34.87, 12.722],
                    [33.732, -15.305],
                    [35.696, -14.479],
                    [34.871, -12.516],
                    [-33.732, 15.51]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [72.916, 79.347], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 9",
          "ix": 9,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.19, 0],
                    [0.239, 0.584],
                    [-0.771, 0.315],
                    [0, 0],
                    [-0.316, -0.77],
                    [0.771, -0.315],
                    [0, 0]
                  ],
                  "o": [
                    [-0.593, 0],
                    [-0.315, -0.77],
                    [0, 0],
                    [0.762, -0.316],
                    [0.315, 0.77],
                    [0, 0],
                    [-0.185, 0.077]
                  ],
                  "v": [
                    [-7.833, 4.809],
                    [-9.229, 3.873],
                    [-8.402, 1.909],
                    [7.265, -4.493],
                    [9.229, -3.669],
                    [8.404, -1.703],
                    [-7.265, 4.697]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [89.856, 45.21], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 10",
          "ix": 10,
          "cix": 2,
          "np": 7,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [70.399, 43.036],
                    [70.396, 43.036],
                    [70.399, 43.035]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [71.255, 45.127],
                    [71.269, 45.127]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-70.538, -42.605],
                    [-20.398, 80.128],
                    [70.092, 43.161],
                    [19.95, -79.572]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 4",
              "ix": 4,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.536, 0],
                    [0.521, 0.219],
                    [0.422, 1.035],
                    [0, 0],
                    [-0.433, 1.031],
                    [-1.035, 0.422],
                    [0, 0],
                    [-0.872, -2.134],
                    [0, 0],
                    [2.134, -0.874],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-0.548, 0],
                    [-1.032, -0.433],
                    [0, 0],
                    [-0.424, -1.033],
                    [0.432, -1.031],
                    [0, 0],
                    [2.142, -0.87],
                    [0, 0],
                    [0.871, 2.135],
                    [0, 0.002],
                    [0, 0],
                    [-0.51, 0.209]
                  ],
                  "v": [
                    [-20.583, 84.753],
                    [-22.202, 84.423],
                    [-24.456, 82.148],
                    [-74.848, -41.206],
                    [-74.833, -44.409],
                    [-72.557, -46.663],
                    [18.553, -83.883],
                    [24.007, -81.592],
                    [74.402, 41.762],
                    [72.111, 47.217],
                    [72.11, 47.219],
                    [-19.001, 84.439]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [75.522, 85.003], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 11",
          "ix": 11,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.984, -0.402],
                    [0, 0],
                    [0.402, 0.984],
                    [0, 0],
                    [-0.983, 0.402],
                    [0, 0],
                    [-0.402, -0.984],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.984, 0.402],
                    [0, 0],
                    [-0.402, -0.984],
                    [0, 0],
                    [0.984, -0.402],
                    [0, 0],
                    [0.402, 0.984]
                  ],
                  "v": [
                    [71.479, 44.848],
                    [-19.631, 82.068],
                    [-22.141, 81.016],
                    [-72.533, -42.339],
                    [-71.48, -44.849],
                    [19.631, -82.069],
                    [22.14, -81.014],
                    [72.533, 42.34]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [75.299, 85.281], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 9
    },
    {
      "ty": 3,
      "nm": "Layer 12 Outlines 7",
      "sr": 1,
      "st": 162,
      "op": 462,
      "ip": 162,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [53.907, 53.907, 100],
              "t": 162
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [62.999, 62.999, 100],
              "t": 222.201
            },
            { "s": [66.459, 66.459, 100], "t": 282 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [318.45, 739.698, 0],
              "t": 162,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 282 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [0],
              "t": 162
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [-56],
              "t": 201
            },
            { "s": [53.642], "t": 282 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "ind": 10
    },
    {
      "ty": 3,
      "nm": "Layer 12 Outlines",
      "sr": 1,
      "st": 33,
      "op": 333,
      "ip": 33,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [53.907, 53.907, 100],
              "t": 33
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 93.201
            },
            { "s": [66.459, 66.459, 100], "t": 153 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [318.45, 739.698, 0],
              "t": 33,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 153 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [360], "t": 33 },
            { "s": [0], "t": 153 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "ind": 11
    },
    {
      "ty": 4,
      "nm": "Layer 6 Outlines",
      "sr": 1,
      "st": 33,
      "op": 333,
      "ip": 33,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [76.107, 85.049, 0], "ix": 1 },
        "s": { "a": 0, "k": [91.425, 91.425, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [94.176, 72.558, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.197, 0],
                    [0.244, 0.574],
                    [-0.766, 0.325],
                    [0, 0],
                    [-0.327, -0.766],
                    [0.767, -0.325],
                    [0, 0]
                  ],
                  "o": [
                    [-0.586, 0],
                    [-0.326, -0.765],
                    [0, 0],
                    [0.761, -0.322],
                    [0.325, 0.765],
                    [0, 0],
                    [-0.191, 0.081]
                  ],
                  "v": [
                    [-21.008, 10.527],
                    [-22.395, 9.609],
                    [-21.597, 7.633],
                    [20.42, -10.205],
                    [22.396, -9.406],
                    [21.597, -7.43],
                    [-20.42, 10.408]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [73.109, 118.977], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.197, 0],
                    [0.244, 0.574],
                    [-0.766, 0.325],
                    [0, 0],
                    [-0.327, -0.766],
                    [0.766, -0.325],
                    [0, 0]
                  ],
                  "o": [
                    [-0.586, 0],
                    [-0.326, -0.765],
                    [0, 0],
                    [0.759, -0.321],
                    [0.325, 0.765],
                    [0, 0],
                    [-0.191, 0.081]
                  ],
                  "v": [
                    [-8.298, 5.13],
                    [-9.686, 4.213],
                    [-8.888, 2.237],
                    [7.71, -4.809],
                    [9.686, -4.01],
                    [8.887, -2.034],
                    [-7.711, 5.012]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [54.763, 105.943], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.197, 0],
                    [0.244, 0.574],
                    [-0.767, 0.325],
                    [0, 0],
                    [-0.327, -0.767],
                    [0.766, -0.325],
                    [0, 0]
                  ],
                  "o": [
                    [-0.586, 0],
                    [-0.326, -0.766],
                    [0, 0],
                    [0.759, -0.324],
                    [0.325, 0.766],
                    [0, 0],
                    [-0.191, 0.082]
                  ],
                  "v": [
                    [-13.557, 7.364],
                    [-14.944, 6.446],
                    [-14.145, 4.47],
                    [12.969, -7.04],
                    [14.945, -6.243],
                    [14.146, -4.267],
                    [-12.969, 7.243]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [101.122, 86.262], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.197, 0],
                    [0.244, 0.574],
                    [-0.766, 0.325],
                    [0, 0],
                    [-0.327, -0.766],
                    [0.766, -0.325],
                    [0, 0]
                  ],
                  "o": [
                    [-0.586, 0],
                    [-0.326, -0.766],
                    [0, 0],
                    [0.758, -0.323],
                    [0.325, 0.766],
                    [0, 0],
                    [-0.191, 0.082]
                  ],
                  "v": [
                    [-34.107, 16.088],
                    [-35.495, 15.17],
                    [-34.697, 13.194],
                    [33.52, -15.765],
                    [35.496, -14.967],
                    [34.697, -12.993],
                    [-33.52, 15.967]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [73.873, 79.206], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.197, 0],
                    [0.244, 0.574],
                    [-0.767, 0.325],
                    [0, 0],
                    [-0.326, -0.767],
                    [0.767, -0.325],
                    [0, 0]
                  ],
                  "o": [
                    [-0.586, 0],
                    [-0.326, -0.766],
                    [0, 0],
                    [0.759, -0.323],
                    [0.325, 0.766],
                    [0, 0],
                    [-0.191, 0.082]
                  ],
                  "v": [
                    [-7.788, 4.915],
                    [-9.176, 3.997],
                    [-8.376, 2.022],
                    [7.201, -4.592],
                    [9.177, -3.794],
                    [8.378, -1.819],
                    [-7.201, 4.795]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [90.344, 44.84], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-70.665, -41.864],
                    [-18.856, 80.174],
                    [71.12, 41.975],
                    [19.311, -80.062]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.555, 0],
                    [0.507, 0.205],
                    [0.437, 1.029],
                    [0, 0],
                    [-2.123, 0.902],
                    [0, 0],
                    [-1.039, -0.418],
                    [-0.436, -1.029],
                    [0, 0],
                    [0.418, -1.036],
                    [1.03, -0.437],
                    [0, 0]
                  ],
                  "o": [
                    [-0.529, 0],
                    [-1.037, -0.419],
                    [0, 0],
                    [-0.9, -2.124],
                    [0, 0],
                    [1.027, -0.437],
                    [1.036, 0.42],
                    [0, 0],
                    [0.437, 1.029],
                    [-0.42, 1.037],
                    [0, 0],
                    [-0.525, 0.222]
                  ],
                  "v": [
                    [-19.035, 84.799],
                    [-20.601, 84.493],
                    [-22.885, 82.248],
                    [-74.958, -40.406],
                    [-72.742, -45.893],
                    [17.854, -84.354],
                    [21.057, -84.381],
                    [23.339, -82.135],
                    [75.412, 40.518],
                    [75.439, 43.72],
                    [73.193, 46.005],
                    [-17.399, 84.465]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [76.107, 85.049], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 7",
          "ix": 7,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.978, -0.415],
                    [0, 0],
                    [0.415, 0.978],
                    [0, 0],
                    [-0.978, 0.415],
                    [0, 0],
                    [-0.416, -0.978],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.978, 0.415],
                    [0, 0],
                    [-0.416, -0.978],
                    [0, 0],
                    [0.979, -0.415],
                    [0, 0],
                    [0.416, 0.978]
                  ],
                  "v": [
                    [72.085, 43.869],
                    [-18.51, 82.329],
                    [-21.033, 81.31],
                    [-73.104, -41.346],
                    [-72.085, -43.869],
                    [18.509, -82.329],
                    [21.033, -81.31],
                    [73.103, 41.346]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [76.334, 85.106], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 12,
      "parent": 11
    },
    {
      "ty": 3,
      "nm": "Layer 12 Outlines 4",
      "sr": 1,
      "st": 68,
      "op": 368,
      "ip": 68,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [53.907, 53.907, 100],
              "t": 68
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [68.999, 68.999, 100],
              "t": 128.201
            },
            { "s": [66.459, 66.459, 100], "t": 188 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [318.45, 739.698, 0],
              "t": 68,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 188 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [720], "t": 68 },
            { "s": [0], "t": 188 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "ind": 13
    },
    {
      "ty": 4,
      "nm": "Layer 15 Outlines 2",
      "sr": 1,
      "st": 68,
      "op": 368,
      "ip": 68,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [84.806, 97.839, 0], "ix": 1 },
        "s": { "a": 0, "k": [103.714, 103.714, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [97.398, 86.2, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.01, 0],
                    [0.015, -0.045],
                    [0, 0],
                    [-0.054, -0.018],
                    [0, 0],
                    [0, 0],
                    [-0.017, 0.054],
                    [0, 0],
                    [0.054, 0.018],
                    [0, 0]
                  ],
                  "o": [
                    [-0.051, 0],
                    [0, 0],
                    [-0.019, 0.054],
                    [0, 0],
                    [0, 0],
                    [0.051, 0.017],
                    [0, 0],
                    [0.019, -0.055],
                    [0, 0],
                    [-0.011, -0.002]
                  ],
                  "v": [
                    [-29.016, -92.914],
                    [-29.141, -92.833],
                    [-79.878, 55.763],
                    [-79.803, 55.917],
                    [28.987, 93.062],
                    [28.989, 93.062],
                    [29.14, 92.987],
                    [79.877, -55.61],
                    [79.801, -55.764],
                    [-28.986, -92.909]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.93, 0],
                    [0.494, 0.169],
                    [0, 0],
                    [0.548, 1.113],
                    [-0.4, 1.173],
                    [0, 0],
                    [-1.114, 0.546],
                    [-1.175, -0.402],
                    [0, 0],
                    [-0.547, -1.112],
                    [0.402, -1.173],
                    [0, 0]
                  ],
                  "o": [
                    [-0.496, 0],
                    [0, 0],
                    [-1.173, -0.4],
                    [-0.546, -1.113],
                    [0, 0],
                    [0.401, -1.173],
                    [1.112, -0.546],
                    [0, 0],
                    [1.174, 0.401],
                    [0.546, 1.114],
                    [0, 0],
                    [-0.659, 1.925]
                  ],
                  "v": [
                    [29.023, 97.589],
                    [27.528, 97.34],
                    [-81.262, 60.195],
                    [-83.93, 57.849],
                    [-84.156, 54.302],
                    [-33.419, -94.294],
                    [-31.071, -96.961],
                    [-27.526, -97.186],
                    [81.262, -60.042],
                    [83.929, -57.695],
                    [84.154, -54.149],
                    [33.419, 94.448]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [84.806, 97.839], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.245, 0.425],
                    [0, 0],
                    [-0.425, 1.245],
                    [0, 0],
                    [-1.244, -0.425],
                    [0, 0],
                    [0.425, -1.245],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.245, -0.425],
                    [0, 0],
                    [0.425, -1.245],
                    [0, 0],
                    [1.245, 0.425],
                    [0, 0],
                    [-0.425, 1.244]
                  ],
                  "v": [
                    [28.258, 95.124],
                    [-80.532, 57.979],
                    [-82.016, 54.956],
                    [-31.281, -93.641],
                    [-28.257, -95.125],
                    [80.532, -57.98],
                    [82.016, -54.957],
                    [31.28, 93.641]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.3725, 0.6078, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [84.806, 97.915], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 14,
      "parent": 13
    },
    {
      "ty": 3,
      "nm": "Layer 12 Outlines 6",
      "sr": 1,
      "st": 13,
      "op": 313,
      "ip": 13,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [53.907, 53.907, 100],
              "t": 13
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 73.201
            },
            { "s": [66.459, 66.459, 100], "t": 133 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [318.45, 739.698, 0],
              "t": 13,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 133 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [360], "t": 13 },
            { "s": [0], "t": 133 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "ind": 15
    },
    {
      "ty": 4,
      "nm": "Layer 15 Outlines 3",
      "sr": 1,
      "st": 13,
      "op": 313,
      "ip": 13,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [84.806, 97.839, 0], "ix": 1 },
        "s": { "a": 0, "k": [103.714, 103.714, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [97.398, 86.2, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.01, 0],
                    [0.015, -0.045],
                    [0, 0],
                    [-0.054, -0.018],
                    [0, 0],
                    [0, 0],
                    [-0.017, 0.054],
                    [0, 0],
                    [0.054, 0.018],
                    [0, 0]
                  ],
                  "o": [
                    [-0.051, 0],
                    [0, 0],
                    [-0.019, 0.054],
                    [0, 0],
                    [0, 0],
                    [0.051, 0.017],
                    [0, 0],
                    [0.019, -0.055],
                    [0, 0],
                    [-0.011, -0.002]
                  ],
                  "v": [
                    [-29.016, -92.914],
                    [-29.141, -92.833],
                    [-79.878, 55.763],
                    [-79.803, 55.917],
                    [28.987, 93.062],
                    [28.989, 93.062],
                    [29.14, 92.987],
                    [79.877, -55.61],
                    [79.801, -55.764],
                    [-28.986, -92.909]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.93, 0],
                    [0.494, 0.169],
                    [0, 0],
                    [0.548, 1.113],
                    [-0.4, 1.173],
                    [0, 0],
                    [-1.114, 0.546],
                    [-1.175, -0.402],
                    [0, 0],
                    [-0.547, -1.112],
                    [0.402, -1.173],
                    [0, 0]
                  ],
                  "o": [
                    [-0.496, 0],
                    [0, 0],
                    [-1.173, -0.4],
                    [-0.546, -1.113],
                    [0, 0],
                    [0.401, -1.173],
                    [1.112, -0.546],
                    [0, 0],
                    [1.174, 0.401],
                    [0.546, 1.114],
                    [0, 0],
                    [-0.659, 1.925]
                  ],
                  "v": [
                    [29.023, 97.589],
                    [27.528, 97.34],
                    [-81.262, 60.195],
                    [-83.93, 57.849],
                    [-84.156, 54.302],
                    [-33.419, -94.294],
                    [-31.071, -96.961],
                    [-27.526, -97.186],
                    [81.262, -60.042],
                    [83.929, -57.695],
                    [84.154, -54.149],
                    [33.419, 94.448]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [84.806, 97.839], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.245, 0.425],
                    [0, 0],
                    [-0.425, 1.245],
                    [0, 0],
                    [-1.244, -0.425],
                    [0, 0],
                    [0.425, -1.245],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.245, -0.425],
                    [0, 0],
                    [0.425, -1.245],
                    [0, 0],
                    [1.245, 0.425],
                    [0, 0],
                    [-0.425, 1.244]
                  ],
                  "v": [
                    [28.258, 95.124],
                    [-80.532, 57.979],
                    [-82.016, 54.956],
                    [-31.281, -93.641],
                    [-28.257, -95.125],
                    [80.532, -57.98],
                    [82.016, -54.957],
                    [31.28, 93.641]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [84.806, 97.915], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 16,
      "parent": 15
    },
    {
      "ty": 3,
      "nm": "Layer 12 Outlines 3",
      "sr": 1,
      "st": 97,
      "op": 397,
      "ip": 97,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [75.522, 85.003, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [53.907, 53.907, 100],
              "t": 97
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [100, 100, 100],
              "t": 157.201
            },
            { "s": [66.459, 66.459, 100], "t": 217 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [318.45, 739.698, 0],
              "t": 97,
              "ti": [45, -224.333, 0],
              "to": [77, -535.667, 0]
            },
            { "s": [756.45, 729.698, 0], "t": 217 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1 }, "s": [360], "t": 97 },
            { "s": [0], "t": 217 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "ind": 17
    },
    {
      "ty": 4,
      "nm": "Layer 15 Outlines",
      "sr": 1,
      "st": 97,
      "op": 397,
      "ip": 97,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [84.806, 97.839, 0], "ix": 1 },
        "s": { "a": 0, "k": [103.714, 103.714, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [97.398, 86.2, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.01, 0],
                    [0.015, -0.045],
                    [0, 0],
                    [-0.054, -0.018],
                    [0, 0],
                    [0, 0],
                    [-0.017, 0.054],
                    [0, 0],
                    [0.054, 0.018],
                    [0, 0]
                  ],
                  "o": [
                    [-0.051, 0],
                    [0, 0],
                    [-0.019, 0.054],
                    [0, 0],
                    [0, 0],
                    [0.051, 0.017],
                    [0, 0],
                    [0.019, -0.055],
                    [0, 0],
                    [-0.011, -0.002]
                  ],
                  "v": [
                    [-29.016, -92.914],
                    [-29.141, -92.833],
                    [-79.878, 55.763],
                    [-79.803, 55.917],
                    [28.987, 93.062],
                    [28.989, 93.062],
                    [29.14, 92.987],
                    [79.877, -55.61],
                    [79.801, -55.764],
                    [-28.986, -92.909]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.93, 0],
                    [0.494, 0.169],
                    [0, 0],
                    [0.548, 1.113],
                    [-0.4, 1.173],
                    [0, 0],
                    [-1.114, 0.546],
                    [-1.175, -0.402],
                    [0, 0],
                    [-0.547, -1.112],
                    [0.402, -1.173],
                    [0, 0]
                  ],
                  "o": [
                    [-0.496, 0],
                    [0, 0],
                    [-1.173, -0.4],
                    [-0.546, -1.113],
                    [0, 0],
                    [0.401, -1.173],
                    [1.112, -0.546],
                    [0, 0],
                    [1.174, 0.401],
                    [0.546, 1.114],
                    [0, 0],
                    [-0.659, 1.925]
                  ],
                  "v": [
                    [29.023, 97.589],
                    [27.528, 97.34],
                    [-81.262, 60.195],
                    [-83.93, 57.849],
                    [-84.156, 54.302],
                    [-33.419, -94.294],
                    [-31.071, -96.961],
                    [-27.526, -97.186],
                    [81.262, -60.042],
                    [83.929, -57.695],
                    [84.154, -54.149],
                    [33.419, 94.448]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [84.806, 97.839], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.245, 0.425],
                    [0, 0],
                    [-0.425, 1.245],
                    [0, 0],
                    [-1.244, -0.425],
                    [0, 0],
                    [0.425, -1.245],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.245, -0.425],
                    [0, 0],
                    [0.425, -1.245],
                    [0, 0],
                    [1.245, 0.425],
                    [0, 0],
                    [-0.425, 1.244]
                  ],
                  "v": [
                    [28.258, 95.124],
                    [-80.532, 57.979],
                    [-82.016, 54.956],
                    [-31.281, -93.641],
                    [-28.257, -95.125],
                    [80.532, -57.98],
                    [82.016, -54.957],
                    [31.28, 93.641]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [84.806, 97.915], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 18,
      "parent": 17
    },
    {
      "ty": 4,
      "nm": "Layer 5 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [105.823, 77.72, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [105.839, 87.289, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [12.381, -0.026],
                    [0, 0],
                    [0.026, 12.381]
                  ],
                  "v": [
                    [80.826, 74.871],
                    [-80.511, 75.21],
                    [-103.071, 52.745],
                    [-103.291, -52.312],
                    [-80.826, -74.871],
                    [80.511, -75.21],
                    [103.07, -52.745],
                    [103.291, 52.312]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.83, 77.72], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 6,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [11.149, 0],
                    [0, 0],
                    [0, 0],
                    [-0.024, -11.167],
                    [0, 0],
                    [-11.147, 0],
                    [0, 0],
                    [0, 0],
                    [-3.83, 3.844],
                    [0.012, 5.385],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [-11.167, 0.024],
                    [0, 0],
                    [0.023, 11.152],
                    [0, 0],
                    [0, 0],
                    [5.385, -0.012],
                    [3.829, -3.846],
                    [0, 0],
                    [-0.022, -11.152]
                  ],
                  "v": [
                    [80.564, -72.951],
                    [80.523, -72.951],
                    [-80.814, -72.613],
                    [-101.023, -52.317],
                    [-100.804, 52.741],
                    [-80.552, 72.949],
                    [-80.508, 72.949],
                    [80.829, 72.611],
                    [95.118, 66.63],
                    [101.038, 52.316],
                    [100.817, -52.742]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [80.833, 74.872],
                    [80.848, 74.872]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0.029, 13.643],
                    [0, 0],
                    [-13.661, 0.029],
                    [0, 0],
                    [0, 0],
                    [-0.028, -13.642],
                    [0, 0],
                    [4.681, -4.701],
                    [6.592, -0.014],
                    [0, 0]
                  ],
                  "o": [
                    [-13.636, 0.001],
                    [0, 0],
                    [-0.03, -13.659],
                    [0, 0],
                    [0, 0],
                    [13.639, 0],
                    [0, 0],
                    [0.015, 6.591],
                    [-4.682, 4.701],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-80.552, 77.469],
                    [-105.324, 52.749],
                    [-105.543, -52.308],
                    [-80.823, -77.132],
                    [80.514, -77.471],
                    [80.564, -77.471],
                    [105.337, -52.749],
                    [105.558, 52.308],
                    [98.321, 69.818],
                    [80.838, 77.13],
                    [-80.499, 77.469]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.823, 77.721], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [12.382, -0.026],
                    [0, 0],
                    [0.026, 12.382],
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-12.382, 0.026],
                    [0, 0],
                    [-0.026, -12.382],
                    [0, 0],
                    [12.381, -0.026],
                    [0, 0],
                    [0.026, 12.381]
                  ],
                  "v": [
                    [80.826, 74.871],
                    [-80.511, 75.21],
                    [-103.071, 52.745],
                    [-103.291, -52.312],
                    [-80.826, -74.871],
                    [80.511, -75.21],
                    [103.07, -52.745],
                    [103.291, 52.312]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.2392, 0.5216, 0.9922], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [105.83, 77.721], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 19,
      "parent": 5
    },
    {
      "ty": 4,
      "nm": "Layer 18 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [81.813, 80.779, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [600.604, 632.19, 0], "ix": 2 },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [-1080],
              "t": 0
            },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 7,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [5.953, 0],
                    [4.966, -1.898],
                    [4.768, -10.515],
                    [-3.977, -10.766],
                    [-10.384, -4.711],
                    [-9.843, 21.698],
                    [21.442, 9.727]
                  ],
                  "o": [
                    [-5.142, 0],
                    [-10.721, 4.1],
                    [-4.772, 10.514],
                    [3.974, 10.761],
                    [21.447, 9.733],
                    [9.844, -21.7],
                    [-5.572, -2.529]
                  ],
                  "v": [
                    [0.4, -42.968],
                    [-14.866, -40.124],
                    [-38.887, -17.461],
                    [-40.119, 15.541],
                    [-17.853, 39.535],
                    [38.889, 17.825],
                    [17.854, -39.171]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [17.499, 0],
                    [6.047, 2.743],
                    [4.255, 11.522],
                    [-5.099, 11.24],
                    [-11.467, 4.384],
                    [-11.122, -5.042],
                    [10.53, -23.214]
                  ],
                  "o": [
                    [-6.259, 0],
                    [-11.125, -5.047],
                    [-4.254, -11.517],
                    [5.101, -11.242],
                    [11.471, -4.387],
                    [22.957, 10.415],
                    [-7.757, 17.097]
                  ],
                  "v": [
                    [-0.449, 46.321],
                    [-19.097, 42.28],
                    [-42.945, 16.586],
                    [-41.633, -18.705],
                    [-15.941, -42.937],
                    [19.098, -41.916],
                    [41.634, 19.07]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [-2.27, -1.03],
                    [-2.339, 0.896],
                    [1.801, 4.875],
                    [0, 0],
                    [0, 0],
                    [-4.92, 7.167],
                    [0, 0],
                    [0, 0],
                    [-2.161, 4.753],
                    [4.692, 2.127],
                    [0, 0],
                    [0, 0],
                    [1.522, 8.538],
                    [0, 0],
                    [0, 0],
                    [1.801, 4.874],
                    [2.27, 1.03],
                    [2.344, -0.894],
                    [0, 0],
                    [0, 0],
                    [7.065, 4.888],
                    [0, 0],
                    [0, 0],
                    [0.872, 2.36],
                    [2.27, 1.028],
                    [2.158, -4.755],
                    [0, 0],
                    [0, 0],
                    [8.482, -1.607],
                    [0, 0],
                    [0, 0],
                    [2.272, 1.03],
                    [2.344, -0.896],
                    [-1.802, -4.876],
                    [0, 0],
                    [0, 0],
                    [4.918, -7.167],
                    [0, 0],
                    [0, 0],
                    [2.346, -0.897],
                    [1.046, -2.307],
                    [-4.692, -2.129],
                    [0, 0],
                    [0, 0],
                    [-1.521, -8.538],
                    [0, 0],
                    [0, 0],
                    [-1.802, -4.875],
                    [-2.27, -1.03],
                    [-2.34, 0.894],
                    [0, 0],
                    [0, 0],
                    [-7.068, -4.891],
                    [0, 0],
                    [0, 0],
                    [-4.692, -2.13],
                    [-2.343, 0.897],
                    [-1.046, 2.307],
                    [0, 0],
                    [0, 0],
                    [-8.48, 1.604]
                  ],
                  "o": [
                    [0, 0],
                    [0.868, 2.354],
                    [2.27, 1.033],
                    [4.854, -1.857],
                    [0, 0],
                    [0, 0],
                    [7.424, -4.477],
                    [0, 0],
                    [0, 0],
                    [4.689, 2.132],
                    [2.157, -4.755],
                    [0, 0],
                    [0, 0],
                    [2.153, -8.419],
                    [0, 0],
                    [0, 0],
                    [4.854, -1.857],
                    [-0.868, -2.354],
                    [-2.269, -1.031],
                    [0, 0],
                    [0, 0],
                    [-4.379, -7.442],
                    [0, 0],
                    [0, 0],
                    [1.048, -2.307],
                    [-0.87, -2.354],
                    [-4.692, -2.133],
                    [0, 0],
                    [0, 0],
                    [-8.334, -2.096],
                    [0, 0],
                    [0, 0],
                    [-0.869, -2.354],
                    [-2.267, -1.029],
                    [-4.855, 1.857],
                    [0, 0],
                    [0, 0],
                    [-7.427, 4.477],
                    [0, 0],
                    [0, 0],
                    [-2.272, -1.032],
                    [-2.349, 0.899],
                    [-2.157, 4.755],
                    [0, 0],
                    [0, 0],
                    [-2.154, 8.419],
                    [0, 0],
                    [0, 0],
                    [-4.855, 1.856],
                    [0.868, 2.354],
                    [2.273, 1.03],
                    [0, 0],
                    [0, 0],
                    [4.374, 7.439],
                    [0, 0],
                    [0, 0],
                    [-2.158, 4.755],
                    [2.274, 1.03],
                    [2.349, -0.899],
                    [0, 0],
                    [0, 0],
                    [8.332, 2.095],
                    [0, 0]
                  ],
                  "v": [
                    [11.723, 59.076],
                    [16.287, 71.435],
                    [21.155, 76.683],
                    [28.31, 76.892],
                    [33.848, 64.683],
                    [29.294, 52.35],
                    [30.361, 51.707],
                    [48.964, 34.16],
                    [49.677, 33.119],
                    [61.604, 38.527],
                    [74.027, 33.765],
                    [69.428, 21.281],
                    [57.503, 15.87],
                    [57.817, 14.646],
                    [58.768, -10.909],
                    [58.549, -12.136],
                    [70.828, -16.831],
                    [76.366, -29.038],
                    [71.498, -34.286],
                    [64.343, -34.493],
                    [52.037, -29.787],
                    [51.39, -30.886],
                    [34.145, -49.468],
                    [33.111, -50.183],
                    [38.575, -62.228],
                    [38.846, -69.466],
                    [33.978, -74.712],
                    [21.554, -69.95],
                    [16.091, -57.904],
                    [14.871, -58.212],
                    [-10.468, -58.95],
                    [-11.722, -58.714],
                    [-16.286, -71.072],
                    [-21.156, -76.32],
                    [-28.309, -76.528],
                    [-33.847, -64.319],
                    [-29.293, -51.987],
                    [-30.36, -51.344],
                    [-48.963, -33.796],
                    [-49.676, -32.754],
                    [-61.602, -38.164],
                    [-68.759, -38.372],
                    [-74.024, -33.402],
                    [-69.428, -20.915],
                    [-57.502, -15.507],
                    [-57.815, -14.283],
                    [-58.767, 11.272],
                    [-58.548, 12.499],
                    [-70.827, 17.194],
                    [-76.365, 29.402],
                    [-71.498, 34.65],
                    [-64.343, 34.858],
                    [-52.036, 30.151],
                    [-51.389, 31.25],
                    [-34.144, 49.831],
                    [-33.11, 50.546],
                    [-38.574, 62.593],
                    [-33.978, 75.078],
                    [-26.821, 75.284],
                    [-21.556, 70.314],
                    [-16.09, 58.269],
                    [-14.87, 58.576],
                    [10.469, 59.313]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 4",
              "ix": 4,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.489, 0],
                    [1.617, 0.734],
                    [1.151, 3.114],
                    [0, 0],
                    [7.956, 1.83],
                    [0, 0],
                    [3.096, -1.185],
                    [3.01, 1.365],
                    [-2.843, 6.268],
                    [0, 0],
                    [4.296, 6.98],
                    [0, 0],
                    [3.011, 1.366],
                    [1.151, 3.115],
                    [-6.388, 2.442],
                    [0, 0],
                    [-1.892, 8.041],
                    [0, 0],
                    [-2.842, 6.27],
                    [-3.096, 1.184],
                    [-3.01, -1.365],
                    [0, 0],
                    [-6.978, 4.392],
                    [0, 0],
                    [-6.388, 2.444],
                    [-3.007, -1.365],
                    [-1.152, -3.116],
                    [0, 0],
                    [-7.96, -1.834],
                    [0, 0],
                    [-6.201, -2.817],
                    [-1.152, -3.115],
                    [1.375, -3.033],
                    [0, 0],
                    [-4.299, -6.982],
                    [0, 0],
                    [-3.01, -1.365],
                    [-1.15, -3.114],
                    [6.389, -2.441],
                    [0, 0],
                    [1.891, -8.04],
                    [0, 0],
                    [2.842, -6.267],
                    [6.204, 2.819],
                    [0, 0],
                    [6.975, -4.392],
                    [0, 0],
                    [6.387, -2.442]
                  ],
                  "o": [
                    [-1.725, 0],
                    [-3.009, -1.365],
                    [0, 0],
                    [-8.085, 1.362],
                    [0, 0],
                    [-1.377, 3.033],
                    [-3.098, 1.184],
                    [-6.205, -2.816],
                    [0, 0],
                    [-6.622, -4.782],
                    [0, 0],
                    [-3.103, 1.187],
                    [-3.009, -1.365],
                    [-2.37, -6.418],
                    [0, 0],
                    [-1.29, -8.143],
                    [0, 0],
                    [-6.204, -2.816],
                    [1.377, -3.033],
                    [3.098, -1.185],
                    [0, 0],
                    [4.806, -6.719],
                    [0, 0],
                    [-2.37, -6.418],
                    [3.105, -1.187],
                    [3.01, 1.364],
                    [0, 0],
                    [8.08, -1.364],
                    [0, 0],
                    [2.844, -6.268],
                    [3.009, 1.364],
                    [1.147, 3.11],
                    [0, 0],
                    [6.619, 4.78],
                    [0, 0],
                    [3.103, -1.187],
                    [3.011, 1.365],
                    [2.369, 6.417],
                    [0, 0],
                    [1.29, 8.145],
                    [0, 0],
                    [6.206, 2.815],
                    [-2.846, 6.269],
                    [0, 0],
                    [-4.807, 6.719],
                    [0, 0],
                    [2.368, 6.416],
                    [-1.436, 0.55]
                  ],
                  "v": [
                    [24.969, 80.529],
                    [19.909, 79.427],
                    [13.459, 72.48],
                    [9.774, 62.499],
                    [-14.38, 61.794],
                    [-18.81, 71.559],
                    [-25.746, 78.099],
                    [-35.222, 77.822],
                    [-41.319, 61.348],
                    [-36.888, 51.582],
                    [-53.328, 33.872],
                    [-63.266, 37.671],
                    [-72.743, 37.394],
                    [-79.193, 30.447],
                    [-71.904, 14.381],
                    [-61.941, 10.57],
                    [-61.036, -13.801],
                    [-70.673, -18.171],
                    [-76.77, -34.647],
                    [-69.834, -41.186],
                    [-60.358, -40.91],
                    [-50.721, -36.537],
                    [-32.979, -53.27],
                    [-36.675, -63.274],
                    [-29.386, -79.342],
                    [-19.911, -79.064],
                    [-13.458, -72.117],
                    [-9.772, -62.136],
                    [14.382, -61.43],
                    [18.811, -71.194],
                    [35.222, -77.456],
                    [41.674, -70.51],
                    [41.321, -60.984],
                    [36.889, -51.219],
                    [53.329, -33.508],
                    [63.266, -37.307],
                    [72.742, -37.03],
                    [79.194, -30.083],
                    [71.905, -14.018],
                    [61.942, -10.207],
                    [61.037, 14.164],
                    [70.672, 18.537],
                    [76.771, 35.009],
                    [60.359, 41.271],
                    [50.722, 36.902],
                    [32.98, 53.633],
                    [36.676, 63.639],
                    [29.387, 79.705]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [81.813, 80.779], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 20
    },
    {
      "ty": 4,
      "nm": "Layer 19 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [68.121, 68.168, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [524.181, 745.808, 0], "ix": 2 },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [1080],
              "t": 0
            },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 7,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [13.547, 0],
                    [4.88, -2.231],
                    [-8.139, -17.801],
                    [-18.013, 8.234],
                    [-3.382, 8.922],
                    [3.942, 8.62]
                  ],
                  "o": [
                    [-5.032, 0],
                    [-18.016, 8.237],
                    [8.14, 17.802],
                    [8.73, -3.992],
                    [3.38, -8.917],
                    [-5.935, -12.979]
                  ],
                  "v": [
                    [0.269, -34.893],
                    [-14.76, -31.605],
                    [-32.671, 15.617],
                    [14.761, 32.962],
                    [33.543, 12.936],
                    [32.672, -14.259]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [5.451, 0],
                    [6.44, 14.085],
                    [-19.525, 8.928],
                    [-8.828, -19.311],
                    [3.666, -9.676],
                    [9.456, -4.322]
                  ],
                  "o": [
                    [-14.691, 0],
                    [-8.83, -19.312],
                    [19.53, -8.929],
                    [4.278, 9.358],
                    [-3.665, 9.668],
                    [-5.284, 2.416]
                  ],
                  "v": [
                    [-0.265, 39.262],
                    [-35.411, 16.87],
                    [-16.014, -34.345],
                    [35.412, -15.512],
                    [36.361, 14.004],
                    [16.014, 35.701]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [-6.206, -3.626],
                    [0, 0],
                    [0, 0],
                    [-0.841, -1.838],
                    [-1.91, -0.699],
                    [-1.494, 3.94],
                    [0, 0],
                    [0, 0],
                    [-7.011, 1.814],
                    [0, 0],
                    [0, 0],
                    [-1.911, -0.698],
                    [-1.87, 0.853],
                    [-0.724, 1.909],
                    [0.84, 1.837],
                    [0, 0],
                    [0, 0],
                    [-3.712, 6.195],
                    [0, 0],
                    [0, 0],
                    [-1.492, 3.94],
                    [0.838, 1.838],
                    [1.911, 0.699],
                    [0, 0],
                    [0, 0],
                    [1.765, 6.936],
                    [0, 0],
                    [0, 0],
                    [-0.724, 1.908],
                    [0.84, 1.837],
                    [1.911, 0.698],
                    [1.871, -0.855],
                    [0, 0],
                    [0, 0],
                    [6.207, 3.628],
                    [0, 0],
                    [0, 0],
                    [0.84, 1.837],
                    [1.912, 0.699],
                    [1.492, -3.943],
                    [0, 0],
                    [0, 0],
                    [7.008, -1.813],
                    [0, 0],
                    [0, 0],
                    [3.851, -1.764],
                    [0.723, -1.909],
                    [-0.84, -1.837],
                    [0, 0],
                    [0, 0],
                    [3.711, -6.196],
                    [0, 0],
                    [0, 0],
                    [1.492, -3.944],
                    [-0.842, -1.837],
                    [-1.909, -0.699],
                    [0, 0],
                    [0, 0],
                    [-1.766, -6.935],
                    [0, 0],
                    [0, 0],
                    [0.724, -1.909],
                    [-0.84, -1.837],
                    [-3.85, 1.757]
                  ],
                  "o": [
                    [0, 0],
                    [4.09, 5.873],
                    [0, 0],
                    [0, 0],
                    [-0.723, 1.902],
                    [0.84, 1.836],
                    [3.956, 1.451],
                    [0, 0],
                    [0, 0],
                    [7.112, 1.247],
                    [0, 0],
                    [0, 0],
                    [0.84, 1.838],
                    [1.916, 0.702],
                    [1.869, -0.855],
                    [0.721, -1.903],
                    [0, 0],
                    [0, 0],
                    [5.957, -4.113],
                    [0, 0],
                    [0, 0],
                    [3.956, 1.452],
                    [0.723, -1.903],
                    [-0.84, -1.838],
                    [0, 0],
                    [0, 0],
                    [1.317, -7.067],
                    [0, 0],
                    [0, 0],
                    [1.87, -0.855],
                    [0.721, -1.903],
                    [-0.84, -1.838],
                    [-1.914, -0.702],
                    [0, 0],
                    [0, 0],
                    [-4.09, -5.872],
                    [0, 0],
                    [0, 0],
                    [0.721, -1.902],
                    [-0.84, -1.838],
                    [-3.956, -1.452],
                    [0, 0],
                    [0, 0],
                    [-7.112, -1.251],
                    [0, 0],
                    [0, 0],
                    [-1.737, -3.797],
                    [-1.87, 0.855],
                    [-0.721, 1.902],
                    [0, 0],
                    [0, 0],
                    [-5.959, 4.114],
                    [0, 0],
                    [0, 0],
                    [-3.959, -1.451],
                    [-0.722, 1.903],
                    [0.84, 1.837],
                    [0, 0],
                    [0, 0],
                    [-1.318, 7.067],
                    [0, 0],
                    [0, 0],
                    [-1.869, 0.854],
                    [-0.721, 1.903],
                    [1.738, 3.8],
                    [0, 0]
                  ],
                  "v": [
                    [-41.989, 28.208],
                    [-41.271, 29.241],
                    [-25.753, 43.555],
                    [-24.654, 44.199],
                    [-28.634, 54.706],
                    [-28.449, 60.507],
                    [-24.185, 64.438],
                    [-14.294, 59.917],
                    [-10.323, 49.437],
                    [-9.096, 49.652],
                    [12.188, 48.797],
                    [13.41, 48.479],
                    [18.054, 58.635],
                    [22.319, 62.568],
                    [28.189, 62.333],
                    [32.209, 58.047],
                    [32.025, 52.248],
                    [27.382, 42.092],
                    [28.42, 41.374],
                    [42.992, 25.838],
                    [43.632, 24.768],
                    [54.156, 28.62],
                    [64.044, 24.099],
                    [63.862, 18.299],
                    [59.595, 14.365],
                    [49.045, 10.504],
                    [49.277, 9.251],
                    [48.602, -11.852],
                    [48.291, -13.072],
                    [58.545, -17.759],
                    [62.566, -22.043],
                    [62.38, -27.843],
                    [58.115, -31.777],
                    [52.245, -31.54],
                    [41.99, -26.85],
                    [41.272, -27.883],
                    [25.753, -42.2],
                    [24.652, -42.843],
                    [28.635, -53.35],
                    [28.451, -59.147],
                    [24.184, -63.082],
                    [14.296, -58.559],
                    [10.322, -48.08],
                    [9.095, -48.295],
                    [-12.187, -47.44],
                    [-13.409, -47.124],
                    [-18.053, -57.279],
                    [-28.188, -60.975],
                    [-32.209, -56.69],
                    [-32.024, -50.891],
                    [-27.381, -40.736],
                    [-28.419, -40.018],
                    [-42.991, -24.481],
                    [-43.631, -23.412],
                    [-54.155, -27.262],
                    [-64.045, -22.742],
                    [-63.859, -16.94],
                    [-59.596, -13.008],
                    [-49.045, -9.146],
                    [-49.278, -7.893],
                    [-48.602, 13.208],
                    [-48.292, 14.428],
                    [-58.545, 19.116],
                    [-62.565, 23.4],
                    [-62.381, 29.2],
                    [-52.245, 32.896]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 4",
              "ix": 4,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [4.345, 0],
                    [1.207, 0.441],
                    [1.177, 2.575],
                    [-1.008, 2.663],
                    [0, 0],
                    [3.975, 5.43],
                    [0, 0],
                    [2.427, 5.311],
                    [-1.009, 2.662],
                    [-2.593, 1.186],
                    [0, 0],
                    [-1.078, 6.668],
                    [0, 0],
                    [1.177, 2.575],
                    [-1.007, 2.663],
                    [-5.503, -2.012],
                    [0, 0],
                    [-5.513, 3.999],
                    [0, 0],
                    [-1.008, 2.661],
                    [-2.595, 1.186],
                    [-2.429, -5.312],
                    [0, 0],
                    [-6.719, -1.02],
                    [0, 0],
                    [-5.501, -2.006],
                    [-1.177, -2.575],
                    [1.008, -2.662],
                    [0, 0],
                    [-3.976, -5.428],
                    [0, 0],
                    [-2.669, -0.977],
                    [-1.177, -2.574],
                    [1.008, -2.662],
                    [2.595, -1.185],
                    [0, 0],
                    [1.079, -6.667],
                    [0, 0],
                    [-1.177, -2.576],
                    [1.009, -2.66],
                    [5.504, 2.006],
                    [0, 0],
                    [5.513, -3.999],
                    [0, 0],
                    [1.01, -2.662],
                    [2.594, -1.186],
                    [2.665, 0.975],
                    [1.177, 2.575],
                    [0, 0],
                    [6.72, 1.018],
                    [0, 0]
                  ],
                  "o": [
                    [-1.22, 0],
                    [-2.672, -0.979],
                    [-1.178, -2.576],
                    [0, 0],
                    [-5.749, -3.545],
                    [0, 0],
                    [-5.36, 2.454],
                    [-1.179, -2.575],
                    [1.006, -2.656],
                    [0, 0],
                    [-1.505, -6.559],
                    [0, 0],
                    [-2.672, -0.978],
                    [-1.179, -2.576],
                    [2.078, -5.477],
                    [0, 0],
                    [3.624, -5.748],
                    [0, 0],
                    [-1.178, -2.576],
                    [1.006, -2.655],
                    [5.358, -2.456],
                    [0, 0],
                    [6.629, -1.552],
                    [0, 0],
                    [2.074, -5.481],
                    [2.674, 0.978],
                    [1.178, 2.576],
                    [0, 0],
                    [5.749, 3.547],
                    [0, 0],
                    [2.594, -1.189],
                    [2.672, 0.979],
                    [1.178, 2.576],
                    [-1.006, 2.654],
                    [0, 0],
                    [1.505, 6.561],
                    [0, 0],
                    [2.673, 0.98],
                    [1.177, 2.576],
                    [-2.075, 5.477],
                    [0, 0],
                    [-3.625, 5.748],
                    [0, 0],
                    [1.179, 2.575],
                    [-1.006, 2.656],
                    [-2.598, 1.187],
                    [-2.672, -0.979],
                    [0, 0],
                    [-6.63, 1.555],
                    [0, 0],
                    [-1.623, 4.277]
                  ],
                  "v": [
                    [-21.559, 67.919],
                    [-25.221, 67.269],
                    [-31.19, 61.76],
                    [-31.453, 53.637],
                    [-28.369, 45.499],
                    [-43.01, 31.988],
                    [-50.992, 35.636],
                    [-65.12, 30.452],
                    [-65.382, 22.333],
                    [-59.799, 16.376],
                    [-51.819, 12.727],
                    [-52.46, -7.188],
                    [-60.631, -10.178],
                    [-66.6, -15.686],
                    [-66.864, -23.809],
                    [-53.119, -30.093],
                    [-44.921, -27.093],
                    [-31.165, -41.768],
                    [-34.764, -49.637],
                    [-35.027, -57.758],
                    [-29.442, -63.714],
                    [-15.313, -58.532],
                    [-11.713, -50.66],
                    [8.383, -51.464],
                    [11.479, -59.627],
                    [25.22, -65.912],
                    [31.191, -60.401],
                    [31.454, -52.281],
                    [28.369, -44.143],
                    [43.011, -30.631],
                    [50.991, -34.28],
                    [59.151, -34.607],
                    [65.12, -29.097],
                    [65.383, -20.975],
                    [59.798, -15.02],
                    [51.818, -11.371],
                    [52.459, 8.544],
                    [60.631, 11.534],
                    [66.601, 17.047],
                    [66.862, 25.167],
                    [53.12, 31.451],
                    [44.922, 28.449],
                    [31.166, 43.124],
                    [34.764, 50.995],
                    [35.026, 59.115],
                    [29.443, 65.072],
                    [21.283, 65.399],
                    [15.314, 59.889],
                    [11.714, 52.016],
                    [-8.384, 52.822],
                    [-11.476, 60.985]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [68.121, 68.169], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 21
    },
    {
      "ty": 4,
      "nm": "Layer 20 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [56.471, 56.458, 0], "ix": 1 },
        "s": { "a": 0, "k": [102.092, 102.092, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [476.665, 634.427, 0], "ix": 2 },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [1080],
              "t": 0
            },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 7,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [7.225, 0],
                    [0.153, -0.003],
                    [5.21, -5.32],
                    [-10.847, -10.624],
                    [-7.408, 0.077],
                    [-5.211, 5.321],
                    [0, 0],
                    [0.034, 7.402],
                    [5.252, 5.143]
                  ],
                  "o": [
                    [-0.152, 0],
                    [-7.402, 0.12],
                    [-10.754, 10.977],
                    [5.25, 5.145],
                    [7.4, -0.119],
                    [0, 0],
                    [5.211, -5.319],
                    [-0.033, -7.397],
                    [-5.143, -5.039]
                  ],
                  "v": [
                    [0.345, -27.706],
                    [-0.111, -27.701],
                    [-19.67, -19.266],
                    [-19.502, 19.907],
                    [0.11, 27.702],
                    [19.667, 19.266],
                    [19.669, 19.266],
                    [27.697, -0.462],
                    [19.5, -19.908]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.17, 0],
                    [5.713, 5.594],
                    [-11.915, 12.165],
                    [-8.2, 0.133],
                    [-5.83, -5.71],
                    [-0.039, -8.207],
                    [5.771, -5.891],
                    [8.2, -0.131]
                  ],
                  "o": [
                    [-8.018, 0],
                    [-12.032, -11.788],
                    [5.77, -5.889],
                    [8.259, -0.159],
                    [5.831, 5.713],
                    [0.038, 8.202],
                    [-5.769, 5.891],
                    [-0.168, 0.003]
                  ],
                  "v": [
                    [-0.35, 30.718],
                    [-21.612, 22.061],
                    [-21.824, -21.377],
                    [-0.16, -30.714],
                    [21.609, -22.062],
                    [30.711, -0.477],
                    [21.82, 21.376],
                    [0.157, 30.714]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 3",
              "ix": 3,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [-5.523, -0.901],
                    [0, 0],
                    [0, 0],
                    [-1.069, -1.048],
                    [-1.474, 0],
                    [-0.031, 0],
                    [0.015, 3.131],
                    [0, 0],
                    [0, 0],
                    [-4.588, 3.275],
                    [0, 0],
                    [0, 0],
                    [-1.517, 0.056],
                    [-1.068, 1.09],
                    [2.214, 2.17],
                    [0, 0],
                    [0, 0],
                    [-0.966, 5.539],
                    [0, 0],
                    [0, 0],
                    [0.015, 3.132],
                    [1.07, 1.049],
                    [1.474, 0],
                    [0.031, 0],
                    [0, 0],
                    [0, 0],
                    [3.22, 4.546],
                    [0, 0],
                    [0, 0],
                    [2.214, 2.168],
                    [1.533, -0.097],
                    [1.068, -1.09],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [5.522, 0.902],
                    [0, 0],
                    [0, 0],
                    [1.069, 1.049],
                    [1.475, 0],
                    [0.031, 0],
                    [-0.015, -3.131],
                    [0, 0],
                    [0, 0],
                    [4.586, -3.276],
                    [0, 0],
                    [0, 0],
                    [1.515, -0.031],
                    [1.068, -1.09],
                    [-0.007, -1.517],
                    [-1.07, -1.047],
                    [0, 0],
                    [0, 0],
                    [0.965, -5.537],
                    [0, 0],
                    [0, 0],
                    [-0.015, -3.131],
                    [-1.07, -1.047],
                    [-1.528, -0.006],
                    [0, 0],
                    [0, 0],
                    [-3.217, -4.543],
                    [0, 0],
                    [0, 0],
                    [-0.007, -1.516],
                    [-1.07, -1.048],
                    [-1.536, 0.051],
                    [-1.07, 1.092]
                  ],
                  "o": [
                    [0, 0],
                    [4.609, 3.125],
                    [0, 0],
                    [0, 0],
                    [0.007, 1.509],
                    [1.048, 1.027],
                    [0.032, 0],
                    [3.131, -0.05],
                    [0, 0],
                    [0, 0],
                    [5.516, -1.08],
                    [0, 0],
                    [0, 0],
                    [1.071, 1.049],
                    [1.516, -0.024],
                    [2.201, -2.247],
                    [0, 0],
                    [0, 0],
                    [3.178, -4.651],
                    [0, 0],
                    [0, 0],
                    [3.132, -0.05],
                    [-0.007, -1.51],
                    [-1.047, -1.025],
                    [-0.032, 0],
                    [0, 0],
                    [0, 0],
                    [-1.015, -5.501],
                    [0, 0],
                    [0, 0],
                    [2.201, -2.247],
                    [-1.069, -1.05],
                    [-1.516, 0.024],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-4.609, -3.123],
                    [0, 0],
                    [0, 0],
                    [-0.007, -1.51],
                    [-1.048, -1.026],
                    [-0.032, 0],
                    [-3.131, 0.05],
                    [0, 0],
                    [0, 0],
                    [-5.516, 1.08],
                    [0, 0],
                    [0, 0],
                    [-1.069, -1.048],
                    [-1.516, 0.025],
                    [-1.069, 1.092],
                    [0.006, 1.51],
                    [0, 0],
                    [0, 0],
                    [-3.179, 4.652],
                    [0, 0],
                    [0, 0],
                    [-3.13, 0.052],
                    [0.007, 1.509],
                    [1.068, 1.049],
                    [0, 0],
                    [0, 0],
                    [1.017, 5.502],
                    [0, 0],
                    [0, 0],
                    [-1.069, 1.09],
                    [0.006, 1.509],
                    [1.069, 1.05],
                    [1.516, -0.024],
                    [0, 0]
                  ],
                  "v": [
                    [-23.054, 31.567],
                    [-22.013, 32.273],
                    [-6.744, 38.339],
                    [-5.486, 38.545],
                    [-5.444, 47.639],
                    [-3.775, 51.604],
                    [0.133, 53.193],
                    [0.227, 53.192],
                    [5.88, 47.423],
                    [5.837, 38.359],
                    [7.06, 38.119],
                    [22.285, 31.555],
                    [23.311, 30.821],
                    [29.766, 37.143],
                    [33.766, 38.731],
                    [37.773, 37.002],
                    [37.749, 28.993],
                    [31.295, 22.673],
                    [32.008, 21.63],
                    [38.255, 6.273],
                    [38.47, 5.045],
                    [47.532, 4.899],
                    [53.184, -0.87],
                    [51.514, -4.839],
                    [47.608, -6.428],
                    [47.514, -6.426],
                    [38.423, -6.279],
                    [38.192, -7.533],
                    [31.81, -22.674],
                    [31.083, -23.701],
                    [37.464, -30.215],
                    [37.44, -38.223],
                    [33.44, -39.812],
                    [29.434, -38.083],
                    [29.434, -38.081],
                    [23.051, -31.568],
                    [22.01, -32.273],
                    [6.742, -38.339],
                    [5.484, -38.546],
                    [5.441, -47.637],
                    [3.772, -51.605],
                    [-0.135, -53.193],
                    [-0.229, -53.193],
                    [-5.881, -47.421],
                    [-5.84, -38.36],
                    [-7.063, -38.119],
                    [-22.288, -31.555],
                    [-23.315, -30.821],
                    [-29.771, -37.144],
                    [-33.769, -38.731],
                    [-37.776, -37.003],
                    [-39.422, -32.96],
                    [-37.752, -28.994],
                    [-31.296, -22.671],
                    [-32.01, -21.628],
                    [-38.257, -6.271],
                    [-38.472, -5.046],
                    [-47.535, -4.9],
                    [-53.187, 0.872],
                    [-51.517, 4.837],
                    [-47.516, 6.426],
                    [-38.427, 6.281],
                    [-38.195, 7.535],
                    [-31.813, 22.674],
                    [-31.086, 23.7],
                    [-37.467, 30.215],
                    [-39.113, 34.257],
                    [-37.443, 38.222],
                    [-33.443, 39.811],
                    [-29.435, 38.083]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 4",
              "ix": 4,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.047, 0],
                    [1.617, 1.583],
                    [0.011, 2.319],
                    [0, 0],
                    [4.342, 2.755],
                    [0, 0],
                    [2.313, -0.037],
                    [1.65, 1.617],
                    [0.01, 2.321],
                    [-1.625, 1.661],
                    [0, 0],
                    [1.091, 5.045],
                    [0, 0],
                    [1.651, 1.615],
                    [0.01, 2.318],
                    [-4.773, 0.078],
                    [0, 0],
                    [-2.811, 4.382],
                    [0, 0],
                    [0.01, 2.322],
                    [-1.627, 1.661],
                    [-2.314, 0.038],
                    [-1.649, -1.616],
                    [0, 0],
                    [-5.067, 1.147],
                    [0, 0],
                    [-4.774, 0.077],
                    [-1.649, -1.616],
                    [-0.011, -2.32],
                    [0, 0],
                    [-4.342, -2.754],
                    [0, 0],
                    [0, 0],
                    [-2.314, 0.037],
                    [-1.652, -1.617],
                    [3.361, -3.434],
                    [0, 0],
                    [-1.089, -5.044],
                    [0, 0],
                    [-1.648, -1.616],
                    [-0.011, -2.32],
                    [4.775, -0.077],
                    [0, 0],
                    [2.809, -4.381],
                    [0, 0],
                    [3.364, -3.432],
                    [2.314, -0.037],
                    [1.65, 1.619],
                    [0, 0],
                    [5.066, -1.146],
                    [0, 0],
                    [4.775, -0.076]
                  ],
                  "o": [
                    [-2.269, 0],
                    [-1.65, -1.617],
                    [0, 0],
                    [-5.069, -0.986],
                    [0, 0],
                    [-1.628, 1.661],
                    [-2.39, 0.076],
                    [-1.649, -1.615],
                    [-0.011, -2.313],
                    [0, 0],
                    [-2.843, -4.283],
                    [0, 0],
                    [-2.282, -0.009],
                    [-1.65, -1.617],
                    [-0.021, -4.775],
                    [0, 0],
                    [1.041, -5.088],
                    [0, 0],
                    [-1.65, -1.617],
                    [-0.011, -2.314],
                    [1.626, -1.661],
                    [2.379, -0.009],
                    [0, 0],
                    [4.322, -2.901],
                    [0, 0],
                    [-0.02, -4.776],
                    [2.341, -0.002],
                    [1.651, 1.615],
                    [0, 0],
                    [5.067, 0.986],
                    [0, 0],
                    [0, 0],
                    [1.627, -1.662],
                    [2.328, -0.073],
                    [3.4, 3.333],
                    [0, 0],
                    [2.844, 4.286],
                    [0, 0],
                    [2.362, 0.019],
                    [1.65, 1.615],
                    [0.023, 4.774],
                    [0, 0],
                    [-1.043, 5.089],
                    [0, 0],
                    [3.402, 3.334],
                    [-1.626, 1.661],
                    [-2.307, 0.059],
                    [0, 0],
                    [-4.324, 2.9],
                    [0, 0],
                    [0.021, 4.776],
                    [-0.047, 0]
                  ],
                  "v": [
                    [0.133, 56.208],
                    [-5.884, 53.755],
                    [-8.458, 47.652],
                    [-8.487, 41.089],
                    [-22.65, 35.459],
                    [-27.283, 40.191],
                    [-33.394, 42.824],
                    [-39.552, 40.374],
                    [-42.126, 34.27],
                    [-39.621, 28.107],
                    [-34.986, 23.376],
                    [-40.907, 9.335],
                    [-47.468, 9.439],
                    [-53.627, 6.99],
                    [-56.2, 0.887],
                    [-47.583, -7.913],
                    [-40.993, -8.019],
                    [-35.196, -22.273],
                    [-39.86, -26.84],
                    [-42.435, -32.947],
                    [-39.928, -39.111],
                    [-33.818, -41.744],
                    [-27.661, -39.295],
                    [-22.998, -34.727],
                    [-8.865, -40.818],
                    [-8.895, -47.408],
                    [-0.276, -56.206],
                    [5.88, -53.756],
                    [8.455, -47.652],
                    [8.486, -41.089],
                    [22.647, -35.46],
                    [27.28, -40.191],
                    [27.28, -40.189],
                    [33.391, -42.825],
                    [39.55, -40.377],
                    [39.618, -28.107],
                    [34.983, -23.376],
                    [40.904, -9.334],
                    [47.466, -9.439],
                    [53.623, -6.99],
                    [56.198, -0.886],
                    [47.579, 7.912],
                    [40.992, 8.018],
                    [35.195, 22.273],
                    [39.857, 26.84],
                    [39.925, 39.11],
                    [33.815, 41.744],
                    [27.658, 39.294],
                    [22.995, 34.727],
                    [8.862, 40.818],
                    [8.893, 47.407],
                    [0.274, 56.205]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [56.471, 56.458], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 22
    },
    {
      "ty": 4,
      "nm": "Layer 21 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [8.854, 8.854, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.854 },
              "s": [937.859, 643.802, 0],
              "t": 0,
              "ti": [10.259, 1.52, 0],
              "to": [-3.706, -0.549, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.112 },
              "i": { "x": 0.667, "y": 0.888 },
              "s": [942.084, 696.28, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [-14.655, -2.171, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.125 },
              "i": { "x": 0.667, "y": 0.875 },
              "s": [883.859, 635.802, 0],
              "t": 150,
              "ti": [-14.739, -2.184, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.11 },
              "i": { "x": 0.667, "y": 1 },
              "s": [924.375, 574.323, 0],
              "t": 231,
              "ti": [-3.671, -0.544, 0],
              "to": [10.153, 1.504, 0]
            },
            { "s": [937.859, 643.802, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -4.752],
                    [4.752, 0],
                    [0, 4.752],
                    [-4.752, 0]
                  ],
                  "o": [
                    [0, 4.752],
                    [-4.752, 0],
                    [0, -4.752],
                    [4.752, 0]
                  ],
                  "v": [
                    [8.604, 0],
                    [0, 8.604],
                    [-8.604, 0],
                    [0, -8.604]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [8.854, 8.854], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 23
    },
    {
      "ty": 4,
      "nm": "Layer 22 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [4.922, 4.921, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.835 },
              "s": [868.658, 585.792, 0],
              "t": 0,
              "ti": [-6.459, 8.739, 0],
              "to": [2.333, -3.157, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.166 },
              "i": { "x": 0.667, "y": 0.834 },
              "s": [847.628, 543.538, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [9.227, -12.484, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.153 },
              "i": { "x": 0.667, "y": 0.847 },
              "s": [902.658, 539.792, 0],
              "t": 150,
              "ti": [9.28, -12.555, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.091 },
              "i": { "x": 0.667, "y": 1 },
              "s": [861.444, 499.786, 0],
              "t": 231,
              "ti": [2.311, -3.127, 0],
              "to": [-6.393, 8.649, 0]
            },
            { "s": [868.658, 585.792, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -2.58],
                    [2.58, 0],
                    [0, 2.58],
                    [-2.58, 0]
                  ],
                  "o": [
                    [0, 2.58],
                    [-2.58, 0],
                    [0, -2.58],
                    [2.58, 0]
                  ],
                  "v": [
                    [4.672, 0],
                    [0, 4.671],
                    [-4.672, 0],
                    [0, -4.671]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [4.921, 4.921], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 24
    },
    {
      "ty": 4,
      "nm": "Layer 23 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [4.921, 4.922, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.875 },
              "s": [838.774, 417.517, 0],
              "t": 0,
              "ti": [0, -9.499, 0],
              "to": [0, 3.432, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.199 },
              "i": { "x": 0.667, "y": 0.801 },
              "s": [882.774, 463.532, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [0, 13.569, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.112 },
              "i": { "x": 0.667, "y": 0.888 },
              "s": [838.774, 467.517, 0],
              "t": 150,
              "ti": [0, 13.647, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.1 },
              "i": { "x": 0.667, "y": 1 },
              "s": [762.774, 435.262, 0],
              "t": 231,
              "ti": [0, 3.399, 0],
              "to": [0, -9.401, 0]
            },
            { "s": [838.774, 417.517, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -2.58],
                    [2.58, 0],
                    [0, 2.58],
                    [-2.58, 0]
                  ],
                  "o": [
                    [0, 2.58],
                    [-2.58, 0],
                    [0, -2.58],
                    [2.58, 0]
                  ],
                  "v": [
                    [4.672, -0.001],
                    [0, 4.672],
                    [-4.672, -0.001],
                    [0, -4.672]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.2392, 0.5216, 0.9922], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [4.921, 4.922], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 25
    },
    {
      "ty": 4,
      "nm": "Layer 24 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [31.219, 26.944, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.778 },
              "s": [743.514, 409.106, 0],
              "t": 0,
              "ti": [-5.697, 5.317, 0],
              "to": [2.058, -1.921, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.179 },
              "i": { "x": 0.667, "y": 0.821 },
              "s": [768.716, 432.784, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [8.143, -7.6, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.1 },
              "i": { "x": 0.667, "y": 0.9 },
              "s": [773.514, 381.106, 0],
              "t": 150,
              "ti": [8.19, -7.644, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.1 },
              "i": { "x": 0.667, "y": 1 },
              "s": [682.554, 360.935, 0],
              "t": 231,
              "ti": [2.039, -1.903, 0],
              "to": [-5.638, 5.262, 0]
            },
            { "s": [743.514, 409.106, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 0.682 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": -0.316 }, "i": { "x": 0.667, "y": 1 }, "s": [55], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.154, 0],
                    [0.631, 0.491],
                    [0, 0],
                    [-0.765, 0.985],
                    [-0.985, -0.765],
                    [0, 0],
                    [0, 0],
                    [-0.992, -0.761],
                    [0.759, -0.99],
                    [0, 0],
                    [0.949, -0.122]
                  ],
                  "o": [
                    [-0.787, 0],
                    [0, 0],
                    [-0.986, -0.766],
                    [0.763, -0.986],
                    [0, 0],
                    [0, 0],
                    [0.76, -0.989],
                    [0.99, 0.76],
                    [0, 0],
                    [-0.582, 0.758],
                    [-0.154, 0.019]
                  ],
                  "v": [
                    [-3.118, 11.866],
                    [-5.295, 11.116],
                    [-13.438, 4.797],
                    [-13.836, 1.626],
                    [-10.667, 1.225],
                    [-3.284, 6.957],
                    [10.255, -10.689],
                    [13.424, -11.105],
                    [13.843, -7.936],
                    [-0.281, 10.472],
                    [-2.656, 11.837]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [32.535, 24.45], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.82, 0],
                    [0.06, -0.006],
                    [0, 0],
                    [-0.1, -0.894],
                    [0, 0],
                    [-0.34, -0.272],
                    [-0.429, 0.046],
                    [0, 0],
                    [0, 0],
                    [0.1, 0.894],
                    [0, 0]
                  ],
                  "o": [
                    [-0.06, 0],
                    [0, 0],
                    [-0.895, 0.1],
                    [0, 0],
                    [0.047, 0.432],
                    [0.34, 0.272],
                    [0, 0],
                    [0, 0],
                    [0.893, -0.099],
                    [0, 0],
                    [-0.093, -0.832]
                  ],
                  "v": [
                    [20.511, -21.836],
                    [20.329, -21.826],
                    [-24.662, -16.826],
                    [-26.103, -15.025],
                    [-22.129, 20.723],
                    [-21.528, 21.816],
                    [-20.329, 22.163],
                    [24.663, 17.163],
                    [24.663, 17.163],
                    [26.103, 15.363],
                    [22.131, -20.384]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.229, 0],
                    [1.102, 0.881],
                    [0.181, 1.634],
                    [0, 0],
                    [-3.371, 0.373],
                    [0, 0],
                    [-0.378, -3.368],
                    [0, 0],
                    [3.37, -0.374],
                    [0, 0]
                  ],
                  "o": [
                    [-1.389, 0],
                    [-1.283, -1.026],
                    [0, 0],
                    [-0.374, -3.372],
                    [0, 0],
                    [3.381, -0.377],
                    [0, 0],
                    [0.373, 3.372],
                    [0, 0],
                    [-0.233, 0.026]
                  ],
                  "v": [
                    [-20.522, 26.694],
                    [-24.351, 25.345],
                    [-26.624, 21.221],
                    [-30.595, -14.525],
                    [-25.16, -21.316],
                    [19.829, -26.318],
                    [26.624, -20.886],
                    [30.597, 14.863],
                    [25.161, 21.655],
                    [-19.829, 26.655]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [31.219, 26.945], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [2.136, -0.237],
                    [0, 0],
                    [0.237, 2.135],
                    [0, 0],
                    [-2.135, 0.237],
                    [0, 0],
                    [-0.238, -2.135],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-2.135, 0.237],
                    [0, 0],
                    [-0.237, -2.136],
                    [0, 0],
                    [2.136, -0.237],
                    [0, 0],
                    [0.238, 2.136]
                  ],
                  "v": [
                    [24.912, 19.24],
                    [-20.08, 24.24],
                    [-24.376, 20.803],
                    [-28.35, -14.944],
                    [-24.913, -19.241],
                    [20.079, -24.241],
                    [24.376, -20.803],
                    [28.348, 14.943]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [31.22, 27.114], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 26
    },
    {
      "ty": 4,
      "nm": "Layer 25 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [10.425, 10.425, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.871 },
              "s": [664.045, 366.181, 0],
              "t": 0,
              "ti": [15.194, 12.535, 0],
              "to": [-5.489, -4.528, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.082 },
              "i": { "x": 0.667, "y": 0.918 },
              "s": [696.834, 319.132, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [-21.714, -17.914, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.111 },
              "i": { "x": 0.667, "y": 0.889 },
              "s": [584.045, 300.181, 0],
              "t": 150,
              "ti": [-21.839, -18.017, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.094 },
              "i": { "x": 0.667, "y": 1 },
              "s": [583.266, 381.488, 0],
              "t": 231,
              "ti": [-5.437, -4.485, 0],
              "to": [15.037, 12.405, 0]
            },
            { "s": [664.045, 366.181, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -5.62],
                    [5.62, 0],
                    [0, 5.62],
                    [-5.62, 0]
                  ],
                  "o": [
                    [0, 5.62],
                    [-5.62, 0],
                    [0, -5.62],
                    [5.62, 0]
                  ],
                  "v": [
                    [10.175, 0],
                    [0, 10.175],
                    [-10.175, 0],
                    [0, -10.175]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [10.425, 10.425], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 27
    },
    {
      "ty": 4,
      "nm": "Layer 26 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [12.548, 12.548, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.901 },
              "s": [549.243, 291.294, 0],
              "t": 0,
              "ti": [11.779, -7.979, 0],
              "to": [-4.255, 2.882, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.105 },
              "i": { "x": 0.667, "y": 0.895 },
              "s": [483.945, 245.786, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [-16.826, 11.398, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.14 },
              "i": { "x": 0.667, "y": 0.86 },
              "s": [487.243, 333.294, 0],
              "t": 150,
              "ti": [-16.922, 11.463, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.132 },
              "i": { "x": 0.667, "y": 1 },
              "s": [550.28, 349.559, 0],
              "t": 231,
              "ti": [-4.215, 2.855, 0],
              "to": [11.657, -7.897, 0]
            },
            { "s": [549.243, 291.294, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -6.792],
                    [6.792, 0],
                    [0, 6.792],
                    [-6.791, 0]
                  ],
                  "o": [
                    [0, 6.792],
                    [-6.791, 0],
                    [0, -6.792],
                    [6.792, 0]
                  ],
                  "v": [
                    [12.298, 0],
                    [-0.001, 12.298],
                    [-12.298, 0],
                    [-0.001, -12.298]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [12.547, 12.548], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 28
    },
    {
      "ty": 4,
      "nm": "Layer 27 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [4.922, 4.921, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.873 },
              "s": [394.833, 324.785, 0],
              "t": 0,
              "ti": [-6.459, 6.839, 0],
              "to": [2.333, -2.471, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.118 },
              "i": { "x": 0.667, "y": 0.882 },
              "s": [439.803, 366.934, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [9.227, -9.77, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.153 },
              "i": { "x": 0.667, "y": 0.847 },
              "s": [428.833, 288.785, 0],
              "t": 150,
              "ti": [9.28, -9.826, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.133 },
              "i": { "x": 0.667, "y": 1 },
              "s": [371.619, 271.128, 0],
              "t": 231,
              "ti": [2.311, -2.447, 0],
              "to": [-6.393, 6.769, 0]
            },
            { "s": [394.833, 324.785, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -2.58],
                    [2.58, 0],
                    [0, 2.58],
                    [-2.58, 0]
                  ],
                  "o": [
                    [0, 2.58],
                    [-2.58, 0],
                    [0, -2.58],
                    [2.58, 0]
                  ],
                  "v": [
                    [4.672, 0],
                    [0, 4.671],
                    [-4.672, 0],
                    [0, -4.671]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.2392, 0.5216, 0.9922], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [4.922, 4.921], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 29
    },
    {
      "ty": 4,
      "nm": "Layer 28 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [33.193, 29.435, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.902 },
              "s": [371.861, 398.399, 0],
              "t": 0,
              "ti": [11.019, 4.94, 0],
              "to": [-3.981, -1.784, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.154 },
              "i": { "x": 0.667, "y": 0.846 },
              "s": [342.324, 322.951, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [-15.74, -7.056, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.185 },
              "i": { "x": 0.667, "y": 0.815 },
              "s": [313.861, 372.399, 0],
              "t": 150,
              "ti": [-15.83, -7.096, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.083 },
              "i": { "x": 0.667, "y": 1 },
              "s": [276.637, 397.091, 0],
              "t": 231,
              "ti": [-3.943, -1.768, 0],
              "to": [10.905, 4.888, 0]
            },
            { "s": [371.861, 398.399, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": 1.365 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 0.362 }, "i": { "x": 0.667, "y": 1 }, "s": [-48], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0.677, 0],
                    [0.255, 0.055],
                    [0.515, 0.806],
                    [0, 0],
                    [-1.052, 0.67],
                    [-0.672, -1.054],
                    [0, 0],
                    [0, 0],
                    [-0.678, -1.051],
                    [1.049, -0.676],
                    [0, 0]
                  ],
                  "o": [
                    [-0.255, 0],
                    [-0.934, -0.204],
                    [0, 0],
                    [-0.669, -1.052],
                    [1.051, -0.668],
                    [0, 0],
                    [0, 0],
                    [1.045, -0.678],
                    [0.677, 1.049],
                    [0, 0],
                    [-0.581, 0.376]
                  ],
                  "v": [
                    [-6.779, 8.809],
                    [-7.546, 8.727],
                    [-9.792, 7.162],
                    [-15.329, -1.538],
                    [-14.636, -4.658],
                    [-11.515, -3.965],
                    [-6.498, 3.921],
                    [12.197, -8.132],
                    [15.321, -7.457],
                    [14.646, -4.332],
                    [-4.856, 8.24]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [36.391, 29.202], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 5,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [-0.206, 0.874],
                    [0, 0],
                    [0.876, 0.208],
                    [0, 0],
                    [0.207, -0.875],
                    [0, 0],
                    [-0.874, -0.208],
                    [0, 0]
                  ],
                  "o": [
                    [0.884, 0.208],
                    [0, 0],
                    [0.208, -0.875],
                    [0, 0],
                    [-0.872, -0.214],
                    [0, 0],
                    [-0.207, 0.876],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [17.492, 24.619],
                    [19.455, 23.41],
                    [27.764, -11.585],
                    [26.553, -13.549],
                    [-17.492, -24.004],
                    [-19.456, -22.793],
                    [-27.763, 12.199],
                    [-26.554, 14.163],
                    [17.493, 24.619]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 2",
              "ix": 2,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [2.785, 0],
                    [0.476, 0.112],
                    [0, 0],
                    [0, 0],
                    [-0.782, 3.3],
                    [0, 0],
                    [-3.293, -0.782],
                    [0, 0],
                    [0.781, -3.3],
                    [0, 0]
                  ],
                  "o": [
                    [-0.468, 0],
                    [0, 0],
                    [0, 0],
                    [-3.298, -0.782],
                    [0, 0],
                    [0.784, -3.298],
                    [0, 0],
                    [3.299, 0.783],
                    [0, 0],
                    [-0.669, 2.823]
                  ],
                  "v": [
                    [17.869, 29.184],
                    [16.45, 29.017],
                    [16.449, 29.017],
                    [-27.597, 18.561],
                    [-32.161, 11.157],
                    [-23.852, -23.838],
                    [-16.449, -28.402],
                    [27.598, -17.947],
                    [32.162, -10.541],
                    [23.852, 24.454]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 1
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 2",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.2196, 0.3882], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [33.193, 29.435], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [2.091, 0.496],
                    [0, 0],
                    [-0.496, 2.091],
                    [0, 0],
                    [-2.091, -0.497],
                    [0, 0],
                    [0.497, -2.091],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-2.09, -0.496],
                    [0, 0],
                    [0.496, -2.091],
                    [0, 0],
                    [2.09, 0.496],
                    [0, 0],
                    [-0.496, 2.091]
                  ],
                  "v": [
                    [16.97, 26.511],
                    [-27.075, 16.055],
                    [-29.962, 11.371],
                    [-21.654, -23.623],
                    [-16.97, -26.51],
                    [27.075, -16.054],
                    [29.961, -11.37],
                    [21.654, 23.624]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [33.193, 29.742], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 30
    },
    {
      "ty": 4,
      "nm": "Layer 29 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [4.921, 4.922, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.871 },
              "s": [300.95, 458.458, 0],
              "t": 0,
              "ti": [-11.399, -0.38, 0],
              "to": [4.118, 0.137, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.199 },
              "i": { "x": 0.667, "y": 0.801 },
              "s": [345.367, 501.338, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [16.283, 0.543, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.128 },
              "i": { "x": 0.667, "y": 0.872 },
              "s": [360.95, 460.458, 0],
              "t": 150,
              "ti": [16.376, 0.546, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.096 },
              "i": { "x": 0.667, "y": 1 },
              "s": [347.043, 391.327, 0],
              "t": 231,
              "ti": [4.079, 0.136, 0],
              "to": [-11.281, -0.376, 0]
            },
            { "s": [300.95, 458.458, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -2.58],
                    [2.58, 0],
                    [0, 2.58],
                    [-2.58, 0]
                  ],
                  "o": [
                    [0, 2.58],
                    [-2.58, 0],
                    [0, -2.58],
                    [2.58, 0]
                  ],
                  "v": [
                    [4.672, 0],
                    [0, 4.672],
                    [-4.672, 0],
                    [0, -4.672]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.2392, 0.5216, 0.9922], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [4.921, 4.922], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 31
    },
    {
      "ty": 4,
      "nm": "Layer 30 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [12.548, 12.548, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.847 },
              "s": [226.972, 461.222, 0],
              "t": 0,
              "ti": [11.537, -2.183, 0],
              "to": [-4.284, 0.811, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.133 },
              "i": { "x": 0.667, "y": 0.867 },
              "s": [212.913, 510.152, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [-21.676, 4.101, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.155 },
              "i": { "x": 0.667, "y": 0.845 },
              "s": [152.972, 475.222, 0],
              "t": 150,
              "ti": [-21.832, 4.13, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.1 },
              "i": { "x": 0.667, "y": 1 },
              "s": [159.758, 419.992, 0],
              "t": 231,
              "ti": [-4.179, 0.791, 0],
              "to": [11.19, -2.117, 0]
            },
            { "s": [226.972, 461.222, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -6.792],
                    [6.792, 0],
                    [0, 6.792],
                    [-6.791, 0]
                  ],
                  "o": [
                    [0, 6.792],
                    [-6.791, 0],
                    [0, -6.792],
                    [6.792, 0]
                  ],
                  "v": [
                    [12.298, 0],
                    [-0.001, 12.298],
                    [-12.298, 0],
                    [-0.001, -12.298]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [12.548, 12.548], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 32
    },
    {
      "ty": 4,
      "nm": "Layer 8 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [4.922, 4.921, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.028 },
              "s": [100, 100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.333, "y": -0.966 },
              "i": { "x": 0.667, "y": 1 },
              "s": [136, 136, 100],
              "t": 150
            },
            { "s": [100, 100, 100], "t": 299 }
          ],
          "ix": 6
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 0.823 },
              "s": [241.041, 545.566, 0],
              "t": 0,
              "ti": [-9.978, -0.935, 0],
              "to": [3.705, 0.347, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.161 },
              "i": { "x": 0.667, "y": 0.839 },
              "s": [259.578, 585.679, 0],
              "t": 69,
              "ti": [0, 0, 0],
              "to": [18.747, 1.758, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.124 },
              "i": { "x": 0.667, "y": 0.876 },
              "s": [305.041, 551.566, 0],
              "t": 150,
              "ti": [18.882, 1.77, 0],
              "to": [0, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0.127 },
              "i": { "x": 0.667, "y": 1 },
              "s": [264.847, 489.611, 0],
              "t": 231,
              "ti": [3.615, 0.339, 0],
              "to": [-9.678, -0.907, 0]
            },
            { "s": [241.041, 545.566, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [
            { "o": { "x": 0.333, "y": 0 }, "i": { "x": 0.667, "y": -16.5 }, "s": [0], "t": 0 },
            { "o": { "x": 0.333, "y": 17.383 }, "i": { "x": 0.667, "y": 1 }, "s": [0], "t": 150 },
            { "s": [0], "t": 299 }
          ],
          "ix": 10
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -2.58],
                    [2.58, 0],
                    [0, 2.58],
                    [-2.58, 0]
                  ],
                  "o": [
                    [0, 2.58],
                    [-2.58, 0],
                    [0, -2.58],
                    [2.58, 0]
                  ],
                  "v": [
                    [4.672, 0],
                    [0.001, 4.671],
                    [-4.672, 0],
                    [0.001, -4.671]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.8706, 0.4157, 0.9098], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [4.922, 4.921], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 33
    },
    {
      "ty": 4,
      "nm": "Layer 31 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [46.217, 46.216, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [1008.503, 482.727, 0],
              "t": 0,
              "ti": [-1, 10.667, 0],
              "to": [-9.333, 2.667, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [952.503, 498.727, 0],
              "t": 60,
              "ti": [-9.333, 2.667, 0],
              "to": [1, -10.667, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [1014.503, 418.727, 0],
              "t": 120,
              "ti": [10.333, -13.333, 0],
              "to": [9.333, -2.667, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [1008.503, 482.727, 0],
              "t": 180,
              "ti": [0, 0, 0],
              "to": [-10.333, 13.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [952.503, 498.727, 0],
              "t": 240,
              "ti": [-9.333, 2.667, 0],
              "to": [0, 0, 0]
            },
            { "s": [1008.503, 482.727, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -25.525],
                    [25.524, 0],
                    [0, 25.525],
                    [-25.525, 0]
                  ],
                  "o": [
                    [0, 25.525],
                    [-25.525, 0],
                    [0, -25.525],
                    [25.524, 0]
                  ],
                  "v": [
                    [46.216, 0],
                    [0, 46.216],
                    [-46.216, 0],
                    [0, -46.216]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.6078, 0.5216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.216, 46.217], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 34
    },
    {
      "ty": 4,
      "nm": "Layer 32 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [14.04, 14.04, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [816.41, 282.466, 0],
              "t": 0,
              "ti": [-11, -7.333, 0],
              "to": [11.333, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [884.41, 282.466, 0],
              "t": 60,
              "ti": [11.333, 0, 0],
              "to": [11, 7.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [882.41, 326.466, 0],
              "t": 120,
              "ti": [-0.333, 7.333, 0],
              "to": [-11.333, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [816.41, 282.466, 0],
              "t": 180,
              "ti": [0, 0, 0],
              "to": [0.333, -7.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [884.41, 282.466, 0],
              "t": 240,
              "ti": [11.333, 0, 0],
              "to": [0, 0, 0]
            },
            { "s": [816.41, 282.466, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-5.483, -5.483],
                    [5.483, -5.483],
                    [5.483, 5.483],
                    [-5.483, 5.483]
                  ],
                  "o": [
                    [5.483, 5.483],
                    [-5.483, 5.483],
                    [-5.483, -5.483],
                    [5.483, -5.483]
                  ],
                  "v": [
                    [9.928, -9.927],
                    [9.928, 9.928],
                    [-9.927, 9.928],
                    [-9.927, -9.927]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.6078, 0.5216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [14.039, 14.04], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 35
    },
    {
      "ty": 4,
      "nm": "Layer 33 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [20.465, 20.465, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [455.367, 239.317, 0],
              "t": 0,
              "ti": [-14.667, 4.333, 0],
              "to": [-14.667, -4.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [367.367, 213.317, 0],
              "t": 60,
              "ti": [-14.667, -4.333, 0],
              "to": [14.667, -4.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [543.367, 213.317, 0],
              "t": 120,
              "ti": [29.333, 0, 0],
              "to": [14.667, 4.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [455.367, 239.317, 0],
              "t": 180,
              "ti": [0, 0, 0],
              "to": [-29.333, 0, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [367.367, 213.317, 0],
              "t": 240,
              "ti": [-14.667, -4.333, 0],
              "to": [0, 0, 0]
            },
            { "s": [455.367, 239.317, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -11.303],
                    [11.303, 0],
                    [0, 11.302],
                    [-11.303, 0]
                  ],
                  "o": [
                    [0, 11.302],
                    [-11.303, 0],
                    [0, -11.303],
                    [11.303, 0]
                  ],
                  "v": [
                    [20.465, 0],
                    [0, 20.465],
                    [-20.465, 0],
                    [0, -20.465]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.6078, 0.5216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [20.465, 20.465], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 36
    },
    {
      "ty": 4,
      "nm": "Layer 34 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [46.216, 46.216, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [82.13, 571.278, 0],
              "t": 0,
              "ti": [2.333, -10.333, 0],
              "to": [-2, -14, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [70.13, 487.278, 0],
              "t": 60,
              "ti": [-2, -14, 0],
              "to": [-2.333, 10.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [68.13, 633.278, 0],
              "t": 120,
              "ti": [-0.333, 24.333, 0],
              "to": [2, 14, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [82.13, 571.278, 0],
              "t": 180,
              "ti": [0, 0, 0],
              "to": [0.333, -24.333, 0]
            },
            {
              "o": { "x": 0.333, "y": 0 },
              "i": { "x": 0.667, "y": 1 },
              "s": [70.13, 487.278, 0],
              "t": 240,
              "ti": [-2, -14, 0],
              "to": [0, 0, 0]
            },
            { "s": [82.13, 571.278, 0], "t": 299 }
          ],
          "ix": 2
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, -25.524],
                    [25.524, 0],
                    [0, 25.525],
                    [-25.525, 0]
                  ],
                  "o": [
                    [0, 25.525],
                    [-25.525, 0],
                    [0, -25.524],
                    [25.524, 0]
                  ],
                  "v": [
                    [46.216, 0],
                    [0, 46.216],
                    [-46.216, 0],
                    [0, -46.216]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [1, 0.6078, 0.5216], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [46.216, 46.216], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 37
    },
    {
      "ty": 4,
      "nm": "Shape Layer 6",
      "sr": 1,
      "st": 56,
      "op": 356,
      "ip": 56,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [142.202, 142.202, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 50, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [394, 394], "ix": 2 }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "d": [
                { "nm": "dash", "n": "d", "v": { "a": 0, "k": 31, "ix": 1 } },
                { "nm": "offset", "n": "o", "v": { "a": 0, "k": 0, "ix": 7 } }
              ],
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [13, 27], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 56
              },
              { "s": [60], "t": 107 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 260, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 73
              },
              { "s": [60], "t": 124 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 38
    },
    {
      "ty": 4,
      "nm": "Shape Layer 3",
      "sr": 1,
      "st": 132,
      "op": 432,
      "ip": 132,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [134.583, 134.583, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 50, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [394, 394], "ix": 2 }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "d": [
                { "nm": "dash", "n": "d", "v": { "a": 0, "k": 31, "ix": 1 } },
                { "nm": "offset", "n": "o", "v": { "a": 0, "k": 0, "ix": 7 } }
              ],
              "c": { "a": 0, "k": [1, 0.4824, 0.7216], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [13, 27], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 132
              },
              { "s": [60], "t": 183 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 260, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 149
              },
              { "s": [60], "t": 200 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 39
    },
    {
      "ty": 4,
      "nm": "Shape Layer 5",
      "sr": 1,
      "st": 106,
      "op": 406,
      "ip": 106,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [124.107, 124.107, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 50, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [394, 394], "ix": 2 }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "d": [
                { "nm": "dash", "n": "d", "v": { "a": 0, "k": 31, "ix": 1 } },
                { "nm": "offset", "n": "o", "v": { "a": 0, "k": 0, "ix": 7 } }
              ],
              "c": { "a": 0, "k": [0.8745, 0.4784, 0.9098], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [13, 27], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 106
              },
              { "s": [60], "t": 157 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 260, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 123
              },
              { "s": [60], "t": 174 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 40
    },
    {
      "ty": 4,
      "nm": "Shape Layer 2",
      "sr": 1,
      "st": 82,
      "op": 382,
      "ip": 82,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [124.107, 124.107, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 50, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [394, 394], "ix": 2 }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "d": [
                { "nm": "dash", "n": "d", "v": { "a": 0, "k": 31, "ix": 1 } },
                { "nm": "offset", "n": "o", "v": { "a": 0, "k": 0, "ix": 7 } }
              ],
              "c": { "a": 0, "k": [0.8745, 0.4784, 0.9098], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [13, 27], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 82
              },
              { "s": [60], "t": 133 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 260, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 99
              },
              { "s": [60], "t": 150 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 41
    },
    {
      "ty": 4,
      "nm": "Shape Layer 4",
      "sr": 1,
      "st": 156,
      "op": 456,
      "ip": 156,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 50, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [394, 394], "ix": 2 }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 4, "ix": 5 },
              "d": [
                { "nm": "dash", "n": "d", "v": { "a": 0, "k": 31, "ix": 1 } },
                { "nm": "offset", "n": "o", "v": { "a": 0, "k": 0, "ix": 7 } }
              ],
              "c": { "a": 0, "k": [0.3725, 0.6078, 1], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [13, 27], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 156
              },
              { "s": [60], "t": 207 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 260, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 173
              },
              { "s": [60], "t": 224 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 42
    },
    {
      "ty": 4,
      "nm": "Shape Layer 1",
      "sr": 1,
      "st": 32,
      "op": 332,
      "ip": 32,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [540, 540, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 50, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": { "a": 0, "k": [394, 394], "ix": 2 }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 4, "ix": 5 },
              "d": [
                { "nm": "dash", "n": "d", "v": { "a": 0, "k": 31, "ix": 1 } },
                { "nm": "offset", "n": "o", "v": { "a": 0, "k": 0, "ix": 7 } }
              ],
              "c": { "a": 0, "k": [0.3725, 0.6078, 1], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [13, 27], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 32
              },
              { "s": [60], "t": 83 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 260, "ix": 3 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0.167 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [0],
                "t": 49
              },
              { "s": [60], "t": 100 }
            ],
            "ix": 1
          },
          "m": 1
        }
      ],
      "ind": 43
    },
    {
      "ty": 4,
      "nm": "Layer 3 Outlines",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [422.409, 297.133, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [550.755, 536.45, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 30, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 1",
          "ix": 1,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [8.522, -27.406],
                    [0.467, -5.252],
                    [7.26, -25.502],
                    [10.256, -29.976],
                    [-18.403, -43.162],
                    [-17.694, -13.37],
                    [-33.611, 2.615],
                    [-50.295, -5.906],
                    [-7.124, -9.475],
                    [-7.62, -10.534],
                    [-2.128, -2.571],
                    [0, 0],
                    [-2.482, 3.957],
                    [1.237, 25.378],
                    [-4.947, 26.228],
                    [-17.972, 26.819],
                    [-2.357, 36.035],
                    [-0.024, 0.409],
                    [59.157, 19.455],
                    [0.004, 0.002],
                    [33.486, 4.732],
                    [22.439, 0.057],
                    [4.892, -0.143],
                    [60.904, -31.971]
                  ],
                  "o": [
                    [-1.608, 5.171],
                    [-2.289, 25.751],
                    [-8.691, 30.532],
                    [-15.154, 44.294],
                    [8.87, 20.801],
                    [27.277, 20.609],
                    [50.024, -3.89],
                    [13.001, 1.526],
                    [8.085, 10.753],
                    [1.962, 2.713],
                    [0, 0],
                    [2.856, -3.705],
                    [13.053, -20.798],
                    [-1.3, -26.693],
                    [6.209, -32.916],
                    [19.848, -29.619],
                    [0.026, -0.408],
                    [3.685, -62.165],
                    [0, 0],
                    [-33.686, -11.078],
                    [-22.672, -3.204],
                    [-4.906, -0.012],
                    [-64.974, 1.909],
                    [-25.412, 13.34]
                  ],
                  "v": [
                    [-305.121, -150.5],
                    [-308.119, -134.858],
                    [-308.983, -57.069],
                    [-353.089, 26.308],
                    [-349.112, 163.397],
                    [-309.592, 216.9],
                    [-212.964, 239.415],
                    [-59.86, 219.775],
                    [-30.965, 238.18],
                    [-9.296, 272.889],
                    [-3.153, 280.812],
                    [259.838, 280.812],
                    [267.865, 269.32],
                    [287.266, 199.061],
                    [280.227, 119.627],
                    [329.21, 29.896],
                    [363.431, -71.08],
                    [363.507, -72.306],
                    [268.824, -210.624],
                    [142.951, -252.022],
                    [42.103, -275.858],
                    [-25.592, -280.812],
                    [-40.288, -280.599],
                    [-229.81, -230.992]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [399.698, 313.453], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 2",
          "ix": 2,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [53.973, -4.086],
                    [9.858, -0.335],
                    [-33.686, -11.079],
                    [0, 0],
                    [3.685, -62.165],
                    [0.026, -0.409],
                    [19.848, -29.619],
                    [6.209, -32.915],
                    [-1.3, -26.693],
                    [13.052, -20.799],
                    [-13.614, 7.846],
                    [-12.042, 39.03],
                    [7.214, 31.845],
                    [-3.883, 34.067],
                    [-0.527, 2.842],
                    [1.749, 20.939],
                    [8.518, 13.396],
                    [49.454, 18.845],
                    [5.001, 1.638]
                  ],
                  "o": [
                    [-11.567, 0.875],
                    [33.486, 4.732],
                    [0.004, 0.001],
                    [59.157, 19.456],
                    [-0.024, 0.409],
                    [-2.357, 36.035],
                    [-17.972, 26.819],
                    [-4.947, 26.229],
                    [1.237, 25.378],
                    [15.222, -4.194],
                    [38.79, -22.353],
                    [9.623, -31.192],
                    [-7.406, -32.695],
                    [0.326, -2.863],
                    [3.84, -20.723],
                    [-1.322, -15.82],
                    [-28.278, -44.475],
                    [-4.938, -1.882],
                    [-51.841, -16.983]
                  ],
                  "v": [
                    [-145.703, -273.095],
                    [-177.729, -271.294],
                    [-76.881, -247.458],
                    [48.992, -206.061],
                    [143.675, -67.742],
                    [143.599, -66.516],
                    [109.378, 34.46],
                    [60.395, 124.19],
                    [67.434, 203.625],
                    [48.034, 273.884],
                    [91.486, 255.946],
                    [169.468, 158.261],
                    [173.099, 66.055],
                    [157.073, -33.667],
                    [158.375, -42.222],
                    [168.648, -104.13],
                    [151.842, -148.19],
                    [28.49, -242.618],
                    [13.576, -247.901]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [619.53, 308.89], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 3",
          "ix": 3,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-26.834, -15.538],
                    [-40.576, 0.337],
                    [-35.43, 8.609],
                    [-17.33, 3.325],
                    [12.994, 1.544],
                    [50.042, -3.519],
                    [27.176, 20.105],
                    [8.769, 20.199],
                    [-15.368, 42.841],
                    [-8.839, 29.539],
                    [-2.413, 24.939],
                    [-1.633, 5.002],
                    [-25.476, 12.798],
                    [-64.983, 1.524],
                    [61.92, 13.155],
                    [43.397, -62.791],
                    [3.354, -6.966],
                    [-6.958, -33.711],
                    [9.038, -42.191],
                    [2.854, -25.44],
                    [-7.778, -17.308]
                  ],
                  "o": [
                    [35.189, 20.375],
                    [36.52, -0.303],
                    [17.312, -4.206],
                    [-7.078, -9.217],
                    [-50.266, -5.973],
                    [-33.624, 2.365],
                    [-17.629, -13.042],
                    [-18.194, -41.911],
                    [10.401, -28.993],
                    [7.383, -24.673],
                    [0.492, -5.086],
                    [8.655, -26.512],
                    [61.058, -30.673],
                    [-36.939, -6.18],
                    [-73.548, -15.625],
                    [-4.426, 6.404],
                    [-15.011, 31.17],
                    [8.181, 39.631],
                    [-5.505, 25.698],
                    [-2.23, 19.884],
                    [12.657, 28.163]
                  ],
                  "v": [
                    [-93.587, 253.945],
                    [23.512, 281.768],
                    [131.947, 266.505],
                    [183.711, 254.082],
                    [154.906, 236.104],
                    [1.708, 254.369],
                    [-94.809, 232.071],
                    [-134.07, 180.035],
                    [-137.383, 47.189],
                    [-92.874, -33.375],
                    [-91.635, -108.741],
                    [-88.561, -123.881],
                    [-12.861, -201.494],
                    [176.899, -248.611],
                    [43.08, -279.055],
                    [-156.493, -177.912],
                    [-168.167, -157.818],
                    [-180.454, -56.935],
                    [-156.025, 55.429],
                    [-165.848, 130.391],
                    [-156.628, 186.591]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [183.711, 299.385], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 4",
          "ix": 4,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-22.672, -3.204],
                    [-11.567, 0.876],
                    [-51.841, -16.982],
                    [-4.938, -1.882],
                    [31.326, 10.854],
                    [54.611, -33.829]
                  ],
                  "o": [
                    [9.858, -0.335],
                    [53.973, -4.085],
                    [5.001, 1.638],
                    [-22.325, -24.557],
                    [-61.999, -21.483],
                    [22.438, 0.057]
                  ],
                  "v": [
                    [-69.262, 4.46],
                    [-37.236, 2.659],
                    [122.043, 27.853],
                    [136.957, 33.136],
                    [54.839, -21.381],
                    [-136.957, -0.494]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [511.063, 33.136], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 5",
          "ix": 5,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [1.963, 2.713],
                    [8.084, 10.753],
                    [17.292, -4.431],
                    [36.517, -0.501],
                    [35.29, 20.847],
                    [12.797, 29.001],
                    [-24.44, -31.53],
                    [0, 0]
                  ],
                  "o": [
                    [-7.62, -10.533],
                    [-17.313, 3.521],
                    [-35.385, 9.066],
                    [-40.574, 0.556],
                    [-26.912, -15.897],
                    [3.572, 39.998],
                    [0, 0],
                    [-2.129, -2.57]
                  ],
                  "v": [
                    [178.098, 47.343],
                    [156.43, 12.635],
                    [104.728, 25.724],
                    [-3.628, 42.035],
                    [-120.866, 13.923],
                    [-184.242, -55.266],
                    [-141.726, 55.266],
                    [184.242, 55.266]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [212.303, 539], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Group 6",
          "ix": 6,
          "cix": 2,
          "np": 3,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [-7.406, -32.695],
                    [9.623, -31.192],
                    [38.79, -22.353],
                    [15.222, -4.194],
                    [2.856, -3.704],
                    [0, 0],
                    [-2.98, 51.307],
                    [1.564, 13.805],
                    [35.602, 40.438],
                    [0.326, -2.863]
                  ],
                  "o": [
                    [7.214, 31.845],
                    [-12.042, 39.03],
                    [-13.615, 7.846],
                    [-2.483, 3.956],
                    [0, 0],
                    [33.042, -39.327],
                    [0.805, -13.878],
                    [-6.062, -53.502],
                    [-0.527, 2.842],
                    [-3.883, 34.067]
                  ],
                  "v": [
                    [40.452, -55.522],
                    [36.821, 36.684],
                    [-41.161, 134.369],
                    [-84.614, 152.307],
                    [-92.642, 163.798],
                    [37.273, 163.798],
                    [92.225, 22.742],
                    [91.106, -18.884],
                    [25.728, -163.798],
                    [24.425, -155.243]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "mm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Merge",
              "nm": "Merge Paths 1",
              "mm": 4
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.502, 0.4627, 0.9059], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [752.177, 430.467], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 44
    }
  ],
  "v": "5.5.9",
  "fr": 60,
  "op": 300,
  "ip": 0,
  "assets": []
}
